(function () {
  "use strict";

  window.Shopify.loadFeatures(
    [
      {
        name: "consent-tracking-api",
        version: "0.1",
      },
    ],
    (error) => {
      if (error) {
        throw error;
      }

      document.dispatchEvent(new CustomEvent("consentCustomer"));
    }
  );

  theme.Sections = function Sections() {
    this.constructors = {};
    this.instances = [];

    document.addEventListener(
      "shopify:section:load",
      this._onSectionLoad.bind(this)
    );
    document.addEventListener(
      "shopify:section:unload",
      this._onSectionUnload.bind(this)
    );
    document.addEventListener(
      "shopify:section:select",
      this._onSelect.bind(this)
    );
    document.addEventListener(
      "shopify:section:deselect",
      this._onDeselect.bind(this)
    );
    document.addEventListener(
      "shopify:block:select",
      this._onBlockSelect.bind(this)
    );
    document.addEventListener(
      "shopify:block:deselect",
      this._onBlockDeselect.bind(this)
    );
  };

  theme.Sections.prototype = Object.assign({}, theme.Sections.prototype, {
    _createInstance: function (container, constructor, scope) {
      var id = container.getAttribute("data-section-id");
      var type = container.getAttribute("data-section-type");

      constructor = constructor || this.constructors[type];

      if (typeof constructor === "undefined") {
        return;
      }

      // If custom scope passed, check to see if instance
      // is already initialized so we don't double up
      if (scope) {
        var instanceExists = this._findInstance(id);
        if (instanceExists) {
          this._removeInstance(id);
        }
      }

      // If a section fails to init, handle the error without letting all subsequest section registers to fail
      try {
        var instance = Object.assign(new constructor(container), {
          id: id,
          type: type,
          container: container,
        });
        this.instances.push(instance);
      } catch (e) {
        console.error(e);
      }
    },

    _findInstance: function (id) {
      for (var i = 0; i < this.instances.length; i++) {
        if (this.instances[i].id === id) {
          return this.instances[i];
        }
      }
    },

    _removeInstance: function (id) {
      var i = this.instances.length;
      var instance;

      while (i--) {
        if (this.instances[i].id === id) {
          instance = this.instances[i];
          this.instances.splice(i, 1);
          break;
        }
      }

      return instance;
    },

    _onSectionLoad: function (evt, subSection, subSectionId) {
      if (window.AOS) {
        AOS.refreshHard();
      }

      document.querySelector("html").classList.remove("overflow-hidden");
      document.querySelector("html").classList.remove("overflow-hidden-fixed");

      if (theme && theme.init) theme.init();

      var container = subSection ? subSection : evt.target;
      var section = subSection
        ? subSection
        : evt.target.querySelector("[data-section-id]");

      if (!section) {
        return;
      }

      this._createInstance(section);

      var instance = subSection
        ? subSectionId
        : this._findInstance(evt.detail.sectionId);

      // Check if we have subsections to load
      var haveSubSections = container.querySelectorAll("[data-subsection]");
      if (haveSubSections.length) {
        this.loadSubSections(container);
      }

      // Run JS only in case of the section being selected in the editor
      // before merchant clicks "Add"
      if (instance && typeof instance.onLoad === "function") {
        instance.onLoad(evt);
      }

      // Force editor to trigger scroll event when loading a section
      setTimeout(function () {
        window.dispatchEvent(new Event("scroll"));
      }, 200);
    },

    _onSectionUnload: function (evt) {
      this.instances = this.instances.filter(function (instance) {
        var isEventInstance = instance.id === evt.detail.sectionId;

        if (isEventInstance) {
          if (typeof instance.onUnload === "function") {
            instance.onUnload(evt);
          }
        }

        return !isEventInstance;
      });
    },

    loadSubSections: function (scope) {
      if (!scope) {
        return;
      }

      var sections = scope.querySelectorAll("[data-section-id]");

      sections.forEach((el) => {
        this._onSectionLoad(null, el, el.dataset.sectionId);
      });
    },

    _onSelect: function (evt) {
      var instance = this._findInstance(evt.detail.sectionId);

      if (
        typeof instance !== "undefined" &&
        typeof instance.onSelect === "function"
      ) {
        instance.onSelect(evt);
      }
    },

    _onDeselect: function (evt) {
      var instance = this._findInstance(evt.detail.sectionId);

      if (
        typeof instance !== "undefined" &&
        typeof instance.onDeselect === "function"
      ) {
        instance.onDeselect(evt);
      }
    },

    _onBlockSelect: function (evt) {
      var instance = this._findInstance(evt.detail.sectionId);

      if (
        typeof instance !== "undefined" &&
        typeof instance.onBlockSelect === "function"
      ) {
        instance.onBlockSelect(evt);
      }
    },

    _onBlockDeselect: function (evt) {
      var instance = this._findInstance(evt.detail.sectionId);

      if (
        typeof instance !== "undefined" &&
        typeof instance.onBlockDeselect === "function"
      ) {
        instance.onBlockDeselect(evt);
      }
    },

    register: function (type, constructor, scope) {
      this.constructors[type] = constructor;

      var sections = document.querySelectorAll(
        '[data-section-type="' + type + '"]'
      );

      if (scope) {
        sections = scope.querySelectorAll('[data-section-type="' + type + '"]');
      }

      sections.forEach(
        function (container) {
          this._createInstance(container, constructor, scope);
        }.bind(this)
      );
    },

    reinit: function (section) {
      for (var i = 0; i < this.instances.length; i++) {
        var instance = this.instances[i];
        if (instance["type"] === section) {
          if (typeof instance.forceReload === "function") {
            instance.forceReload();
          }
        }
      }
    },
  });

  /* --- Section: Header */
  theme.Header = (function () {
    function Header(container) {
      var self = this;

      this.start, this.end;

      this.container = container;
      this.namespace = ".header";
      window.metas.page.a = "#metas_page";
      this.sectionId = this.container.dataset.sectionId;

      if (this.container.querySelector("[data-menu-a]")) {
        this.initHamburger();
      }

      if (document.querySelector(".menu-section")) {
        setTimeout(function () {
          self.initMenu();
        }, 500);
        this.initSticky();
        this.setHeight();

        document.addEventListener("shopify:section:load", function (e) {
          if (self.sectionId == e.target.id) {
            window.scrollTo(0, 0);
          }

          if (self.container.querySelector("[data-menu-a]"))
            self.initHamburger();
          self.unbindSticky();
          self.initMenu();
          self.initSticky();
          self.setHeight();
        });

        window.on(
          "resize" + this.namespace,
          theme.utils.debounce(300, function () {
            if (self.container.querySelector("[data-menu-a]"))
              self.initHamburger();
            self.initMenu();
            self.initSticky();
            self.setHeight();
            ControlOverlay();
          })
        );
      }

      if (this.container.querySelectorAll(".cart-link").length > 0) {
        this.container.querySelectorAll(".cart-link").forEach((link) =>
          link.addEventListener("click", function (e) {
            e.preventDefault();
            e.stopPropagation();
            if (!this.closest("details").hasAttribute("open"))
              this.closest("summary").click();
          })
        );
      }
    }

    Header.prototype = Object.assign({}, Header.prototype, {
      initHamburger() {
        if (document.documentElement.clientWidth >= 780) {
          let menu_a = this.container.querySelector("[data-menu-a]"),
            menu_b;

          if (!menu_a.dataset.insetWidth)
            menu_a.dataset.insetWidth = this.container.querySelector(
              "[data-menu-a] > .inline-flex"
            ).clientWidth;

          if (
            menu_a.clientWidth <
            (this.container.querySelector("[data-menu-a] > .inline-flex")
              .clientWidth >= menu_a.dataset.insetWidth
              ? this.container.querySelector("[data-menu-a] > .inline-flex")
                  .clientWidth
              : menu_a.dataset.insetWidth)
          ) {
            this.container.classList.add("header__hamburger");
            this.menu_a_overdrop = true;
          } else {
            this.menu_a_overdrop = false;
          }

          if (this.container.querySelector("[data-menu-b]")) {
            menu_b = this.container.querySelector("[data-menu-b]");
            if (!menu_b.dataset.insetWidth)
              menu_b.dataset.insetWidth = this.container.querySelector(
                "[data-menu-b] > .inline-flex"
              ).clientWidth;

            if (
              menu_b.clientWidth <
              (this.container.querySelector("[data-menu-a] > .inline-flex")
                .clientWidth >= menu_b.dataset.insetWidth
                ? this.container.querySelector("[data-menu-b] > .inline-flex")
                    .clientWidth
                : menu_b.dataset.insetWidth)
            ) {
              this.container.classList.add("header__hamburger");
              this.menu_b_overdrop = true;
            } else {
              this.menu_b_overdrop = false;
            }
          }

          if (this.menu_a_overdrop || (this.menu_b_overdrop && menu_b)) {
            if (!this.container.classList.contains("header__hamburger")) {
              if (this.menu_a_overdrop)
                menu_a.dataset.insetWidth = this.container.querySelector(
                  "[data-menu-a] > .inline-flex"
                ).clientWidth;
              if (menu_b && this.menu_b_overdrop)
                menu_b.dataset.insetWidth = this.container.querySelector(
                  "[data-menu-b] > .inline-flex"
                ).clientWidth;
              this.container.classList.add("header__hamburger");
            }
          } else if (this.container.classList.contains("header__hamburger"))
            this.container.classList.remove("header__hamburger");
        }
      },

      initMenu() {
        this.container
          .querySelectorAll("span.pseudo-megamenu")
          .forEach((pseudo) => {
            pseudo.style.width =
              pseudo.closest("a.header__link").getBoundingClientRect().width +
              "px";
          });
        this.container
          .querySelectorAll("span.pseudo-megamenu")
          .forEach((pseudo) => {
            pseudo.style.height =
              document.querySelector(".menu-section").offsetHeight -
              (pseudo.closest("a.header__link").getBoundingClientRect().top -
                document.querySelector(".menu-section").getBoundingClientRect()
                  .top) +
              "px";
          });

        this.container
          .querySelectorAll(".header__menu .header__link")
          .forEach((link) => {
            if (theme.utils.next(link, ".header__menu-child")) {
              const screenWidth = document.documentElement.clientWidth * 0.75;

              if (link.getBoundingClientRect().left > screenWidth) {
                theme.utils.next(link, ".header__menu-child").style.left =
                  link.getBoundingClientRect().left +
                  link.getBoundingClientRect().width -
                  theme.utils
                    .next(link, ".header__menu-child")
                    .getBoundingClientRect().width +
                  "px";
              } else {
                theme.utils.next(link, ".header__menu-child").style.left =
                  link.getBoundingClientRect().left + "px";
              }

              var childlinks = theme.utils
                .next(link, ".header__menu-child")
                .querySelectorAll(".header__childlink");

              childlinks.forEach((childlink) => {
                if (theme.utils.next(childlink, ".header__menu-grandchild")) {
                  if (link.getBoundingClientRect().left > screenWidth) {
                    theme.utils.next(
                      childlink,
                      ".header__menu-grandchild"
                    ).style.left =
                      -theme.utils
                        .next(childlink, ".header__menu-grandchild")
                        .getBoundingClientRect().width + "px";
                  } else {
                    theme.utils.next(
                      childlink,
                      ".header__menu-grandchild"
                    ).style.right =
                      -theme.utils
                        .next(childlink, ".header__menu-grandchild")
                        .getBoundingClientRect().width + "px";
                  }
                }
              });
            }
          });
      },

      initSticky() {
        var self = this;
        this.dataScroll = this.container.dataset.scroll;
        this.dataScrollMob = this.container.dataset.scrollMob;
        this.scrollPos = 0;
        if (
          ((this.dataScroll != "none" &&
            document.documentElement.clientWidth >= 780) ||
            (this.dataScrollMob != "none" &&
              document.documentElement.clientWidth < 780)) &&
          document.documentElement.clientHeight + 200 <
            document.body.getBoundingClientRect().height
        ) {
          this.scroll =
            document.documentElement.clientWidth >= 780
              ? this.dataScroll
              : this.dataScrollMob;
          document.body.classList.remove("header__not-sticky");
          this.bindSticky();
        } else {
          document.body.classList.add("header__not-sticky");
        }

        window.on(
          "resize" + this.namespace,
          theme.utils.debounce(300, function () {
            self.unbindSticky();
            self.setHeight();
            if (
              ((self.dataScroll != "none" &&
                document.documentElement.clientWidth >= 780) ||
                (self.dataScrollMob != "none" &&
                  document.documentElement.clientWidth < 780)) &&
              document.documentElement.clientHeight + 200 <
                document.body.getBoundingClientRect().height
            ) {
              self.scroll =
                document.documentElement.clientWidth >= 780
                  ? self.dataScroll
                  : self.dataScrollMob;
              document.body.classList.remove("header__not-sticky");
              self.bindSticky();
            } else {
              document.body.classList.add("header__not-sticky");
            }
          })
        );
      },

      setHeight() {
        this.containerHeight = document.querySelector(
          ".menu-section.shopify-section"
        ).offsetHeight;

        if (document.querySelector(".announce_bar"))
          this.containerHeight +=
            document.querySelector(".announce_bar").offsetHeight;

        document.querySelector("#shopify-header-section").style.height =
          this.containerHeight + "px";
      },

      bindSticky() {
        var self = this;
        var height = 0;

        if (this.scroll == "sticky" || this.scroll == "up") {
          if (this.scroll == "sticky") {
            window.on(
              "scroll" + this.namespace,
              self.onScrollSticky.bind(self)
            );
          } else if (this.scroll == "up") {
            window.on("scroll" + this.namespace, self.onScrollUp.bind(self));
          }

          if (document.querySelector(".announce_bar .header__bar_sticky"))
            height += document
              .querySelector(".announce_bar")
              .getBoundingClientRect().height;

          height += document
            .querySelector(".menu-section")
            .getBoundingClientRect().height;
        } else {
          this.unbindSticky();
        }

        document.querySelectorAll(".position--sticky").forEach((sticky) => {
          var contentSticky = new VanillaSticky({
            HTMLElement: sticky,
            indents: {
              top: height + 20,
              bottom: 20,
            },
            stretch: false,
            window: {
              min: 780,
              max: null,
            },
          });
          contentSticky.init();
        });
      },

      onScrollUp() {
        var self = this;
        if (window.pageYOffset > this.containerHeight) {
          if (window.pageYOffset < this.scrollPos) {
            this.scrollUp();
          } else if (window.pageYOffset > this.scrollPos) {
            this.scrollDown();
          }

          if (
            document.body.classList.contains("header__noscroll") ||
            !document.body.classList.contains("header__sticky")
          ) {
            setTimeout(function () {
              self.initMenu();
            }, 500);
            document.body.classList.add("header__sticky");
          }
        } else {
          this.scrollUp();
          document.body.classList.add("header__noscroll");
          this.unsetSticky();
        }
        this.scrollPos = window.pageYOffset;
      },

      onScrollSticky() {
        var self = this;
        if (window.pageYOffset > this.containerHeight) {
          this.scrollUp();
          if (
            document.body.classList.contains("header__noscroll") ||
            !document.body.classList.contains("header__sticky")
          ) {
            setTimeout(function () {
              self.initMenu();
            }, 500);
            document.body.classList.add("header__sticky");
          }
        } else if (document.body.classList.contains("header__sticky")) {
          this.unsetSticky();
        }

        this.scrollPos = window.pageYOffset;
      },

      scrollUp() {
        document.body.classList.remove("scroll_down");
        document.body.classList.add("scroll_up");
        document.body.classList.remove("header__noscroll");
      },

      scrollDown() {
        document.body.classList.remove("scroll_up");
        document.body.classList.add("scroll_down");
        document.body.classList.remove("header__noscroll");
      },

      unsetSticky() {
        var self = this;
        setTimeout(function () {
          self.initMenu();
        }, 500);
        document.body.classList.remove("scroll_down");
        document.body.classList.remove("scroll_up");
        document.body.classList.remove("header__sticky");
        document.body.classList.add("header__noscroll");
      },

      unbindSticky() {
        var self = this;
        this.scrollPos = 0;
        document.body.classList.remove("header__sticky");
        document.querySelector("#shopify-header-section").style.height = "";
        window.off(
          "scroll" + this.namespace,
          theme.utils.debounce(10, function () {
            self.onScroll();
          })
        );
      },
    });

    return Header;
  })();

  /* --- Plugin: Swiper */
  theme.Swiper_Slider = (function () {
    function Swiper_Slider(container) {
      var self = this;
      this.container = container;
      this.sectionId = container.getAttribute("data-section-id");

      this.data = {
        speed: parseInt(container.getAttribute("data-speed")),
        pagination:
          container.getAttribute("data-pagination") == "false"
            ? false
            : container.getAttribute("data-pagination") == "line"
            ? "bullets"
            : container.getAttribute("data-pagination"),
        effect: container.getAttribute("data-effect")
          ? container.getAttribute("data-effect")
          : "slide",
        action: container.getAttribute("data-action"),
        parallax: container.getAttribute("data-parallax") ? true : false,
        direction: container.getAttribute("data-direction")
          ? container.getAttribute("data-direction")
          : "horizontal",

        active: container.getAttribute("data-active") ? true : false,
        drag: container.getAttribute("data-drag") ? true : false,
        loop: container.getAttribute("data-loop") ? true : false,
        arrows: container.getAttribute("data-arrows") != "false" ? true : false,
        ratio: container.getAttribute("data-ratio")
          ? parseFloat(container.getAttribute("data-ratio"))
          : false,
        padding: container.getAttribute("data-padding")
          ? parseInt(container.getAttribute("data-padding"))
          : false,
        height: container.getAttribute("data-height")
          ? container.getAttribute("data-height")
          : false,
        width: container.getAttribute("data-width")
          ? parseInt(container.getAttribute("data-width"))
          : false,
        shown: container.getAttribute("data-shown")
          ? parseInt(container.getAttribute("data-shown"))
          : null,

        active_Mob: container.getAttribute("datamob-active") ? true : false,
        drag_Mob: container.getAttribute("datamob-drag") ? true : false,
        loop_Mob: container.getAttribute("datamob-loop") ? true : false,
        arrows_Mob:
          container.getAttribute("datamob-arrows") != "false" ? true : false,
        padding_Mob: container.getAttribute("datamob-padding")
          ? parseInt(container.getAttribute("datamob-padding"))
          : false,
        height_Mob: container.getAttribute("datamob-height")
          ? container.getAttribute("datamob-height")
          : false,
        width_Mob: container.getAttribute("datamob-width")
          ? container.getAttribute("datamob-width")
          : false,
        ratio_Mob:
          container.getAttribute("datamob-ratio") != false
            ? parseFloat(container.getAttribute("datamob-ratio"))
            : false,
        shown_Mob: container.getAttribute("datamob-shown")
          ? parseInt(container.getAttribute("datamob-shown"))
          : null,
      };

      this.settings();
    }

    Swiper_Slider.prototype = Object.assign({}, Swiper_Slider.prototype, {
      settings: function () {
        var self = this;

        this.parameters = {
          loop: self.data.loop_Mob,
          parallax: self.data.parallax,
          direction: "horizontal",
          a11y: {
            prevSlideMessage: Shopify.translation.slideshow.prevSlideMessage,
            nextSlideMessage: Shopify.translation.slideshow.nextSlideMessage,
            firstSlideMessage: Shopify.translation.slideshow.firstSlideMessage,
            lastSlideMessage: Shopify.translation.slideshow.lastSlideMessage,
            paginationBulletMessage:
              Shopify.translation.slideshow.paginationBulletMessage,
          },
          breakpoints: {
            780: {
              direction: self.data.direction,
              loop: self.data.loop,
            },
          },
        };

        //Desktop & Tablet Parameters
        if (self.data.active) {
          if (!self.data.active_Mob) {
            var parameters = self.parameters;
          } else {
            var parameters = self.parameters.breakpoints[780];
          }

          /* -- Drag slider */
          if (!self.data.drag) {
            Object.assign(parameters, { allowTouchMove: 0 });
          } else {
            Object.assign(parameters, { grabCursor: !0 });
          }

          /* -- Set Height Full or Adapt */
          if (self.data.height == "adapt" && !self.data.ratio) {
            self.container
              .querySelectorAll(".swiper-slide")
              .forEach((slide) => {
                slide.style.paddingBottom =
                  document.documentElement.clientHeight + "px";
                slide.querySelectorAll(".slideshow-image").forEach((image) => {
                  image.style.paddingBottom =
                    document.documentElement.clientHeight + "px";
                });
              });
            if (self.data.parallax)
              self.container.style.paddingBottom =
                document.documentElement.clientHeight + "px";
          } else if (
            document.documentElement.clientWidth > 780 &&
            self.data.height == "adapt" &&
            self.data.ratio
          ) {
            self.container
              .querySelectorAll(".swiper-slide")
              .forEach((slide) => {
                slide.style.paddingBottom = self.data.ratio * 100 + "%";
                if (
                  slide.querySelectorAll(
                    ".slideshow-image:not(.medium-up--hide)"
                  ).length > 0
                ) {
                  slide
                    .querySelectorAll(".slideshow-image:not(.medium-up--hide)")
                    .forEach((image) => {
                      image.style.paddingBottom = self.data.ratio * 100 + "%";
                    });
                }
              });
            if (self.data.parallax)
              self.container.style.paddingBottom = self.data.ratio * 100 + "%";
          }

          /* -- Set padding */
          if (self.data.padding) {
            Object.assign(parameters, { spaceBetween: self.data.padding });
          }
        }

        //Mobile self.Parameters
        if (self.data.active_Mob) {
          /* -- Drag slider */
          if (!self.data.drag_Mob) {
            Object.assign(self.parameters, { allowTouchMove: 0 });
          } else {
            Object.assign(self.parameters, { grabCursor: !0 });
          }

          if (self.data.height_Mob == "adapt" && !self.data.ratio_Mob) {
            self.container
              .querySelectorAll(".swiper-slide")
              .forEach((slide) => {
                slide.style.paddingBottom =
                  document.documentElement.clientHeight + "px";
                slide.querySelectorAll(".slideshow-image").forEach((image) => {
                  image.style.paddingBottom =
                    document.documentElement.clientHeight + "px";
                });
              });
            if (self.data.parallax)
              self.container.style.paddingBottom =
                document.documentElement.clientHeight + "px";
          } else if (
            document.documentElement.clientWidth <= 779 &&
            self.data.height_Mob == "adapt" &&
            self.data.ratio_Mob
          ) {
            self.container
              .querySelectorAll(".swiper-slide")
              .forEach((slide) => {
                slide.style.paddingBottom = self.data.ratio_Mob * 100 + "%";
                if (
                  slide.querySelectorAll(".slideshow-image.medium-up--hide")
                    .length > 0
                ) {
                  slide
                    .querySelectorAll(".slideshow-image.medium-up--hide")
                    .forEach((image) => {
                      image.style.paddingBottom =
                        self.data.ratio_Mob * 100 + "%";
                    });
                }
              });
            if (self.data.parallax)
              self.container.style.paddingBottom =
                self.data.ratio_Mob * 100 + "%";
          }

          /* -- Set padding */
          if (self.data.padding_Mob) {
            Object.assign(self.parameters, {
              spaceBetween: self.data.padding_Mob,
            });
          }
        }

        /* -- Slide effect */
        if (self.data.effect != "slide") {
          if (self.data.effect == "fade" || self.data.effect == "flip") {
            Object.assign(self.parameters, {
              effect: self.data.effect,
              centeredSlides: true,
            });
          } else if (self.data.effect == "cube") {
            Object.assign(self.parameters, {
              effect: self.data.effect,
              centeredSlides: true,
              spaceBetween: 0,
              breakpoints: {
                780: {
                  spaceBetween: 0,
                },
              },
              watchSlidesProgress: !0,
              cubeEffect: {
                shadow: true,
                slideShadows: true,
                shadowOffset: 20,
                shadowScale: 0.94,
              },
            });
          } else if (self.data.effect == "coverflow") {
            Object.assign(self.parameters, {
              effect: self.data.effect,
              centeredSlides: true,
              slidesPerView: "auto",
              coverflowEffect: {
                rotate: 50,
                stretch: 0,
                depth: 100,
                modifier: 1,
                slideShadows: true,
              },
            });
          } else if (self.data.effect == "cards") {
            Object.assign(self.parameters, {
              effect: self.data.effect,
              coverflowEffect: {
                rotate: 50,
                stretch: 0,
                depth: 100,
                modifier: 1,
                slideShadows: true,
              },
            });
          } else if (self.data.effect == "carousel") {
            Object.assign(self.parameters, {
              slidesPerView: "auto",
              centeredSlides: true,
              watchSlidesProgress: !0,
              on: {
                progress(e) {
                  const t = e.slides.length;
                  for (let r = 0; r < e.slides.length; r += 1) {
                    const o = e.slides[r],
                      s = e.slides[r].progress,
                      i = Math.abs(s);
                    let n = 1;
                    i > 1 && (n = 0.3 * (i - 1) + 1);
                    const l = o.querySelectorAll(
                        ".carousel-slider-animate-opacity"
                      ),
                      a = s * n * 50 + "%",
                      c = 1 - 0.2 * i,
                      d = t - Math.abs(Math.round(s));
                    (o.style.transform = `translateX(${a}) scale(${c})`),
                      (o.style.zIndex = d),
                      (o.style.opacity = i > 3 ? 0 : 1),
                      l.forEach((e) => {
                        e.style.opacity = 1 - i / 3;
                      });
                  }
                },
                setTransition(e, t) {
                  for (let r = 0; r < e.slides.length; r += 1) {
                    const o = e.slides[r],
                      s = o.querySelectorAll(
                        ".carousel-slider-animate-opacity"
                      );
                    (o.style.transitionDuration = `${t}ms`),
                      s.forEach((e) => {
                        e.style.transitionDuration = `${t}ms`;
                      });
                  }
                },
              },
            });
          } else if (self.data.effect == "fashion") {
            let o = !1,
              l = !1,
              i;
            const t = (e) => {
              e.classList.add("fashion-slider-no-transition"),
                (l = !0),
                cancelAnimationFrame(i),
                (i = requestAnimationFrame(() => {
                  e.classList.remove("fashion-slider-no-transition"),
                    (l = !1),
                    (o = !1);
                }));
            };
            Object.assign(self.parameters, {
              speed: 1300,
              allowTouchMove: !0,
              parallax: !0,
              on: {
                transitionStart(e) {
                  const {
                    slides: r,
                    previousIndex: s,
                    activeIndex: n,
                    $el: a,
                  } = e;
                  l || (o = !0);
                  const f = r.eq(n),
                    u = r.eq(s),
                    v = u.find(".fashion-slider-scale"),
                    m = u.find("img"),
                    g = f.find("img"),
                    p = n - s,
                    y = f.attr("data-slide-bg-color");
                  var u1 = u
                      .find(".fashion-slider-text")
                      .attr("data-swiper-color"),
                    v1 = u
                      .find(".fashion-slider-title")
                      .attr("data-swiper-color"),
                    w1 = u
                      .find(".fashion-slider-pre-title")
                      .attr("data-swiper-color"),
                    x1 = u
                      .find(".fashion-slider-sub-title")
                      .attr("data-swiper-color");
                  a.css("background-color", y),
                    v.transform("scale(0.6)"),
                    m.transition(1e3).transform("scale(1.2)");
                  if (u.find(".fashion-slider-text").length > 0)
                    u.find(".fashion-slider-text")
                      .transition(1e3)
                      .css("color", u1);
                  if (u.find(".fashion-slider-title").length > 0)
                    u.find(".fashion-slider-title")
                      .transition(1e3)
                      .css("color", v1);
                  if (u.find(".fashion-slider-pre-title").length > 0)
                    u.find(".fashion-slider-pre-title > *")
                      .transition(1e3)
                      .css("color", w1);
                  if (u.find(".fashion-slider-sub-title").length > 0)
                    u.find(".fashion-slider-sub-title > *")
                      .transition(1e3)
                      .css("color", x1);
                  m.transitionEnd(() => {
                    g
                      .transition(1300)
                      .transform("translate3d(0, 0, 0) scale(1)"),
                      m
                        .transition(1300)
                        .transform(`translate3d(${60 * p}%, 0, 0)  scale(1)`);
                  });
                },
                transitionEnd(e) {
                  const { slides: r, activeIndex: s, $el: n } = e,
                    a = r.eq(s),
                    f = a.find("img");
                  var u = a
                      .find(".fashion-slider-text")
                      .attr("data-swiper-color"),
                    v = a
                      .find(".fashion-slider-title")
                      .attr("data-swiper-color"),
                    w = a
                      .find(".fashion-slider-pre-title")
                      .attr("data-swiper-color"),
                    x = a
                      .find(".fashion-slider-sub-title")
                      .attr("data-swiper-color");
                  a.find(".fashion-slider-scale").transform("scale(1)"),
                    f.transition(1e3).transform("scale(1)");
                  if (a.find(".fashion-slider-text").length > 0)
                    a.find(".fashion-slider-text")
                      .transition(1e3)
                      .css("color", u.replace(", 0)", ", 1)"));
                  if (a.find(".fashion-slider-title").length > 0)
                    a.find(".fashion-slider-title")
                      .transition(1e3)
                      .css("color", v.replace(", 0)", ", 1)"));
                  if (a.find(".fashion-slider-pre-title").length > 0)
                    a.find(".fashion-slider-pre-title > *")
                      .transition(1e3)
                      .css("color", w.replace(", 0)", ", 1)"));
                  if (a.find(".fashion-slider-sub-title").length > 0)
                    a.find(".fashion-slider-sub-title > *")
                      .transition(1e3)
                      .css("color", x.replace(", 0)", ", 1)"));
                  f.transitionEnd(() => {
                    o = !1;
                  });
                },
                init(e) {
                  const { slides: r, activeIndex: s, $el: n } = e;
                  t(n);
                  const a = r.eq(s).attr("data-slide-bg-color");
                  n.css("background-color", a), e.emit("transitionEnd");
                },
                resize(e) {
                  t(e.$el);
                },
              },
            });
          } else if (self.data.effect == "panorama") {
            self.container.classList.add("swiper-3d");
            let count = self.data.shown > 5 ? 5 : self.data.shown;
            let countMob = self.data.shown_Mob > 2 ? 2 : self.data.shown_Mob;
            Object.assign(self.parameters, {
              centeredSlides: true,
              slidesPerView: countMob * 1.5,
              loopedSlides: 10,
              loop: !0,
              watchSlidesProgress: !0,
              panorama: {
                depth: countMob * 150,
                rotate: countMob * 45,
              },
              breakpoints: {
                480: {
                  slidesPerView: count * 2,
                  panorama: {
                    rotate: count * 175,
                    depth: count * 75,
                  },
                },
                780: {
                  slidesPerView: count * 0.6,
                  panorama: {
                    rotate: count * 6,
                    depth: count * 3,
                  },
                },
                1024: {
                  slidesPerView: count * 0.8,
                  panorama: {
                    rotate: count * 6,
                    depth: count * 4,
                  },
                },
                1200: {
                  slidesPerView: count,
                  panorama: {
                    rotate: count * 5,
                    depth: count * 50,
                  },
                },
              },
              on: {
                progress(a) {
                  const r = a.slidesSizesGrid,
                    { depth: e = 200, rotate: t = 30 } = a.params.panorama,
                    f = (t * Math.PI) / 180 / 2,
                    p = 1 / (180 / t);
                  for (let i = 0; i < a.slides.length; i += 1) {
                    const d = a.slides[i],
                      u = d.progress,
                      c = r[i],
                      g = a.params.centeredSlides
                        ? 0
                        : (a.params.slidesPerView - 1) * 0.5,
                      l = u + g,
                      m = 1 - Math.cos(l * p * Math.PI),
                      h = `${l * (c / 3) * m}px`,
                      P = l * t,
                      y = `${((c * 0.5) / Math.sin(f)) * m - e}px`;
                    d.style.transform = `translateX(${h}) translateZ(${y}) rotateY(${P}deg)`;
                  }
                },
                setTransition(a, t) {
                  for (let r = 0; r < a.slides.length; r += 1) {
                    const o = a.slides[r];
                    o.style.transitionDuration = `${t}ms`;
                  }
                },
              },
            });
          } else if (self.data.effect == "spring") {
            self.container.classList.add("swiper-3d");
            let a = 0,
              t,
              e;
            Object.assign(self.parameters, {
              effect: "creative",
              creativeEffect: {
                limitProgress: 100,
                prev: {
                  translate: ["-100%", 0, 0],
                },
                next: {
                  translate: ["100%", 0, 0],
                },
              },
              speed: 720,
              slidesPerView: self.data.shown_mob,
              breakpoints: {
                780: {
                  slidesPerView: self.data.shown,
                },
              },
              followFinger: !1,
              on: {
                touchStart(...n) {
                  (t = !0), n.on && n.on.touchStart && n.on.touchStart(...n);
                },
                touchEnd(...n) {
                  (t = !1), n.on && n.on.touchStart && n.on.touchEnd(...n);
                },
                progress(n, u) {
                  if (t) return;
                  n.on && n.on.progress && n.on.progress(n, u);
                  const g = n.progress > a ? "next" : "prev";
                  a = n.progress;
                  const y = n.params.speed / 16,
                    f = n.visibleSlidesIndexes,
                    h = f[0],
                    m = f[f.length - 1],
                    v = (l, c) => {
                      g === "next" && c >= h
                        ? (l.style.transitionDelay = `${(c - h + 1) * y}ms`)
                        : g === "prev" && c <= m + 1
                        ? (l.style.transitionDelay = `${(m - c + 1) * y}ms`)
                        : (l.style.transitionDelay = `${0}ms`);
                    };
                  n.slides.forEach((l, c) => {
                    n.animating
                      ? ((l.style.transitionDelay = "0ms"),
                        requestAnimationFrame(() => {
                          v(l, c);
                        }))
                      : v(l, c);
                  });
                },
              },
            });
          } else if (self.data.effect == "triple") {
            const tripleContainer = self.container.closest(".triple-slider");
            const previousContainer = self.container.cloneNode(!0);
            const nextContainer = self.container.cloneNode(!0);

            previousContainer.querySelector(".swiper-button-prev")
              ? previousContainer.querySelector(".swiper-button-prev").remove()
              : null;
            previousContainer.querySelector(".swiper-button-next")
              ? previousContainer.querySelector(".swiper-button-next").remove()
              : null;
            previousContainer.querySelector(".swiper-scrollbar")
              ? previousContainer.querySelector(".swiper-scrollbar").remove()
              : null;
            previousContainer.querySelector(".swiper-pagination")
              ? previousContainer.querySelector(".swiper-pagination").remove()
              : null;
            previousContainer.classList.add("triple-slider-prev");

            nextContainer.querySelector(".swiper-button-prev")
              ? nextContainer.querySelector(".swiper-button-prev").remove()
              : null;
            nextContainer.querySelector(".swiper-button-next")
              ? nextContainer.querySelector(".swiper-button-next").remove()
              : null;
            nextContainer.querySelector(".swiper-scrollbar")
              ? nextContainer.querySelector(".swiper-scrollbar").remove()
              : null;
            nextContainer.querySelector(".swiper-pagination")
              ? nextContainer.querySelector(".swiper-pagination").remove()
              : null;
            nextContainer.classList.add("triple-slider-next");

            const t = previousContainer.querySelectorAll(".swiper-slide"),
              l = t[t.length - 1];
            previousContainer
              .querySelector(".swiper-wrapper")
              .insertBefore(l, t[0]);
            const i = nextContainer.querySelectorAll(".swiper-slide")[0];

            tripleContainer.insertBefore(previousContainer, self.container);
            tripleContainer.appendChild(nextContainer);
            nextContainer.querySelector(".swiper-wrapper").appendChild(i),
              self.container.classList.add("triple-slider-main");
            self.container.querySelector(".swiper-button-prev")
              ? tripleContainer.appendChild(
                  self.container.querySelector(".swiper-button-prev")
                )
              : null;
            self.container.querySelector(".swiper-button-next")
              ? tripleContainer.appendChild(
                  self.container.querySelector(".swiper-button-next")
                )
              : null;
            self.container.querySelector(".swiper-scrollbar")
              ? tripleContainer.appendChild(
                  self.container.querySelector(".swiper-scrollbar")
                )
              : null;
            self.container.querySelector(".swiper-pagination")
              ? tripleContainer.appendChild(
                  self.container.querySelector(".swiper-pagination")
                )
              : null;
            (self.y = new Swiper(previousContainer, {
              speed: 600,
              loop: !0,
              parallax: !0,
              slidesPerView: 1,
              navigation: false,
              allowTouchMove: !1,
              on: {
                click() {
                  self.swiper.slidePrev();
                },
              },
            })),
              (self.m = new Swiper(nextContainer, {
                speed: 600,
                loop: !0,
                parallax: !0,
                slidesPerView: 1,
                navigation: false,
                allowTouchMove: !1,
                on: {
                  click() {
                    self.swiper.slideNext();
                  },
                },
              }));

            Object.assign(self.parameters, {
              grabCursor: !0,
              speed: 600,
              loop: !0,
              slidesPerView: 1,
              breakpoints: {
                780: {
                  slidesPerView: 1,
                },
              },
              parallax: !0,
              controller: {
                control: [self.y, self.m],
              },
              on: {
                destroy() {
                  self.y.destroy(), self.m.destroy();
                },
              },
            });
          } else if (self.data.effect.includes("creative")) {
            if (self.data.effect == "creative-1") {
              var creativeEffect = {
                prev: {
                  shadow: true,
                  translate: [0, 0, -400],
                },
                next: {
                  translate: ["100%", 0, 0],
                },
              };
            } else if (self.data.effect == "creative-2") {
              var creativeEffect = {
                prev: {
                  shadow: true,
                  translate: ["-120%", 0, -500],
                },
                next: {
                  shadow: true,
                  translate: ["120%", 0, -500],
                },
              };
            } else if (self.data.effect == "creative-3") {
              var creativeEffect = {
                prev: {
                  shadow: true,
                  translate: ["-20%", 0, -1],
                },
                next: {
                  translate: ["100%", 0, 0],
                },
              };
            } else if (self.data.effect == "creative-4") {
              var creativeEffect = {
                prev: {
                  shadow: true,
                  translate: [0, 0, -800],
                  rotate: [180, 0, 0],
                },
                next: {
                  shadow: true,
                  translate: [0, 0, -800],
                  rotate: [-180, 0, 0],
                },
              };
            } else if (self.data.effect == "creative-5") {
              var creativeEffect = {
                prev: {
                  shadow: true,
                  translate: ["-125%", 0, -800],
                  rotate: [0, 0, -90],
                },
                next: {
                  shadow: true,
                  translate: ["125%", 0, -800],
                  rotate: [0, 0, 90],
                },
              };
            } else if (self.data.effect == "creative-6") {
              var creativeEffect = {
                prev: {
                  shadow: true,
                  origin: "left center",
                  translate: ["-5%", 0, -200],
                  rotate: [0, 100, 0],
                },
                next: {
                  origin: "right center",
                  translate: ["5%", 0, -200],
                  rotate: [0, -100, 0],
                },
              };
            }

            Object.assign(self.parameters, {
              effect: "creative",
              creativeEffect,
            });
          }
        } else {
          /* --- Set for vertical autoHeight */
          if (
            self.data.direction == "vertical" &&
            self.container.classList.contains("product__media--thumbnails")
          ) {
            if (document.documentElement.clientWidth > 780) {
              const slideItemHeight =
                self.container.querySelectorAll(".product__media-item")[0]
                  .clientHeight + self.data.padding;
              const mainSlider = self.container
                .closest(".product__media__container")
                .querySelector(".product__media--main");
              const mainSliderHeight = mainSlider.clientHeight;
              const slidePerView = parseInt(
                Math.floor(mainSliderHeight / slideItemHeight)
              );
              self.container.style.height = mainSliderHeight + "px";

              Object.assign(self.parameters, {
                slidesPerView: slidePerView,
              });
            }
          } else {
            Object.assign(self.parameters.breakpoints[780], {
              slidesPerView: self.data.shown,
            });
          }

          Object.assign(self.parameters, {
            slidesPerView: self.data.shown_Mob,
          });
        }

        /* -- Set parents elements */
        if (self.data.effect == "triple") {
          self.parent = self.container.closest(".triple-slider");
        } else {
          self.parent = self.container;
        }

        if (
          self.data.width &&
          self.data.effect != "slide" &&
          self.data.effect != "spring" &&
          self.data.effect != "panorama" &&
          self.data.effect != "carousel"
        ) {
          Object.assign(self.parameters, {
            width: self.data.width,
          });
        }

        /* -- Show Pagination */
        if (self.data.pagination && self.data.pagination != "scrollbar") {
          Object.assign(self.parameters, {
            pagination: {
              clickable: true,
              el: self.parent.querySelector(".swiper-pagination"),
              type: self.data.pagination,
              dynamicBullets: !0,
              dynamicBullets: 5,
            },
          });
        }

        /* -- Show scrollbar */
        if (self.data.pagination == "scrollbar") {
          Object.assign(self.parameters, {
            scrollbar: {
              el: self.parent.querySelector(".swiper-scrollbar"),
              draggable: !0,
            },
          });
        }

        /* -- Show arrows */
        if (self.data.arrows || self.data.arrows_Mob) {
          Object.assign(self.parameters, {
            navigation: {
              nextEl: self.parent.querySelector(".swiper-button-next"),
              prevEl: self.parent.querySelector(".swiper-button-prev"),
            },
          });
        }

        /* -- Set Continuous slide or autoplay */
        if (self.data.action == "continuous") {
          Object.assign(self.parameters, {
            autoplay: { delay: 1 },
            allowTouchMove: 0,
            speed: self.data.speed * 1e3,
            simulateTouch: false,
            disableOnInteraction: true,
            autoplayDisableOnInteraction: true,
            pauseOnMouseEnter: true,
          });
        } else if (self.data.action == "auto") {
          Object.assign(self.parameters, {
            autoplay: {
              delay: self.data.speed * 1e3,
            },
          });
        }
        this.init();
      },

      getSlideShow: function (desktop = false) {
        let slideShown = 0;
        if (this.data.direction == "vertical" && desktop) {
          let slideHeight =
            this.container.querySelector(".swiper-slide").offsetHeight + 30;

          slideShown = Math.floor(this.container.offsetHeight / slideHeight);
        } else {
          let slideWidth =
            this.container.querySelector(".swiper-slide").offsetWidth + 30;

          slideShown = Math.floor(this.container.offsetWidth / slideWidth);
        }

        return slideShown;
      },

      init: function () {
        var self = this;

        if (
          (!this.data.active && this.data.active_Mob) ||
          (!this.data.active_Mob && this.data.active)
        ) {
          if (!this.data.active && document.documentElement.clientWidth < 779) {
            self.swiper = new Swiper(self.container, self.parameters);
            if (this.data.loop_Mob) {
              self.removeHnLoop();
              self.setImageVisible();
            }

            if (
              self.container.querySelectorAll("deferred-media").length > 0 &&
              !self.data.parallax
            ) {
              self.media();
            }
          }

          if (
            !this.data.active_Mob &&
            document.documentElement.clientWidth > 780
          ) {
            self.swiper = new Swiper(self.container, self.parameters);
            if (this.data.loop) {
              self.removeHnLoop();
              self.setImageVisible();
            }

            self.container.on("mouseenter", function () {
              self.swiper.autoplay.start();
            });

            self.container.on("mouseleave", function () {
              self.swiper.autoplay.start();
            });

            if (
              self.container.querySelectorAll("deferred-media").length > 0 &&
              !self.data.parallax
            ) {
              self.media();
            }
          }
        } else {
          this.swiper = new Swiper(this.container, this.parameters);
          if (
            (this.data.loop && document.documentElement.clientWidth >= 780) ||
            (this.data.loop_Mob && document.documentElement.clientWidth < 780)
          ) {
            self.removeHnLoop();
            self.setImageVisible();
          }

          if (
            self.container.querySelectorAll("deferred-media").length > 0 &&
            !self.data.parallax
          ) {
            self.media();
          }
        }

        self.onResize();
      },

      onUnload: function () {},

      onLoad: function () {
        this.swiper.update();
      },

      setImageVisible() {
        if ("IntersectionObserver" in window) {
          let lazyBackgroundObserver = new IntersectionObserver(function (
            entries,
            observer
          ) {
            entries.forEach(function (entry) {
              if (entry.isIntersecting) {
                entry.target.classList.add("visible");
                lazyBackgroundObserver.unobserve(entry.target);
              }
            });
          });

          document.querySelectorAll("img", "svg").forEach((lazyBackground) => {
            lazyBackgroundObserver.observe(lazyBackground);
          });
        }
      },

      removeHnLoop: function () {
        var self = this;
        var duplicateSlides = self.container.querySelectorAll(
          ".swiper-slide-duplicate"
        );
        duplicateSlides.forEach((slide) => {
          const Hn = slide.querySelector(".slideshow--title:not(p)");
          if (Hn) {
            const p = document.createElement("p");
            p.innerHTML = Hn.innerHTML;
            p.classList = Hn.classList;
            p.dataset.swiperColor = Hn.dataset.swiperColor;
            Hn.parentNode.replaceChild(p, Hn);
          }
        });
      },

      onResize: function () {
        var self = this;

        window.addEventListener("resize", function () {
          if (
            self.data.direction == "vertical" &&
            self.container.classList.contains("product__media--thumbnails")
          ) {
            if (document.documentElement.clientWidth > 780) {
              const slideItemHeight =
                self.container.querySelectorAll(".product__media-item")[0]
                  .clientHeight + self.data.padding;
              const mainSlider = self.container
                .closest(".product__media__container")
                .querySelector(".product__media--main");
              const mainSliderHeight = mainSlider.clientHeight;
              const slidePerView = parseInt(
                Math.floor(mainSliderHeight / slideItemHeight)
              );
              self.container.style.height = mainSliderHeight + "px";
              self.parameters.breakpoints[780].slidesPerView = slidePerView;
            } else {
              self.container.style.height = "";
            }
          }

          if (
            (!self.data.active && self.data.active_Mob) ||
            (!self.data.active_Mob && self.data.active)
          ) {
            if (
              (!self.data.active &&
                document.documentElement.clientWidth < 779) ||
              (!self.data.active_Mob &&
                document.documentElement.clientWidth > 780)
            ) {
              if (self.swiper && typeof self.swiper.activeIndex === "number") {
                return;
              }

              self.swiper = new Swiper(self.container, self.parameters);

              if (
                self.container.querySelector(".swiper-button-prev") &&
                self.container
                  .querySelector(".swiper-button-prev")
                  .classList.contains("swiper-button-lock")
              ) {
                self.container
                  .querySelector(".swiper-button-prev")
                  .classList.remove("swiper-button-lock");
              }

              if (
                self.container.querySelector(".swiper-button-next") &&
                self.container
                  .querySelector(".swiper-button-next")
                  .classList.contains("swiper-button-lock")
              ) {
                self.container
                  .querySelector(".swiper-button-next")
                  .classList.remove("swiper-button-lock");
              }
            } else {
              self.swiper.destroy();
            }
          }

          if (document.documentElement.clientWidth > 780) {
            if (self.data.loop) {
              self.removeHnLoop();
              self.setImageVisible();
            }

            if (self.data.height == "adapt") {
              if (!self.data.ratio) {
                self.container
                  .querySelectorAll(".swiper-slide")
                  .forEach((slide) => {
                    slide.style.paddingBottom =
                      document.documentElement.clientHeight + "px";
                    slide
                      .querySelectorAll(".slideshow-image")
                      .forEach((image) => {
                        image.style.paddingBottom =
                          document.documentElement.clientHeight + "px";
                      });
                  });
                if (self.data.parallax)
                  self.container.style.paddingBottom =
                    document.documentElement.clientHeight + "px";
              } else {
                self.container
                  .querySelectorAll(".swiper-slide")
                  .forEach((slide) => {
                    slide.style.paddingBottom = self.data.ratio * 100 + "%";
                    if (
                      slide.querySelectorAll(".slideshow-image.medium-up--hide")
                        .length > 0
                    ) {
                      slide
                        .querySelectorAll(".slideshow-image.medium-up--hide")
                        .forEach((image) => {
                          image.style.paddingBottom =
                            self.data.ratio * 100 + "%";
                        });
                    }
                  });
                if (self.data.parallax)
                  self.container.style.paddingBottom =
                    self.data.ratio * 100 + "%";
              }
            } else {
              self.container
                .querySelectorAll(".swiper-slide")
                .forEach((slide) => {
                  slide.style.paddingBottom = self.data.height + "px";
                  slide
                    .querySelectorAll(".slideshow-image")
                    .forEach((image) => {
                      image.style.paddingBottom = self.data.height + "px";
                    });
                });
              if (self.data.parallax)
                self.container.style.paddingBottom = self.data.height + "px";
            }
          }

          if (document.documentElement.clientWidth <= 779) {
            if (self.data.loop_Mob) {
              self.removeHnLoop();
              self.setImageVisible();
            }

            if (self.data.height_Mob == "adapt") {
              if (!self.data.ratio_Mob) {
                self.container
                  .querySelectorAll(".swiper-slide")
                  .forEach((slide) => {
                    slide.style.paddingBottom =
                      document.documentElement.clientHeight + "px";
                    slide
                      .querySelectorAll(".slideshow-image")
                      .forEach((image) => {
                        image.style.paddingBottom =
                          document.documentElement.clientHeight + "px";
                      });
                  });
                if (self.data.parallax)
                  self.container.style.paddingBottom =
                    document.documentElement.clientHeight + "px";
              } else {
                self.container
                  .querySelectorAll(".swiper-slide")
                  .forEach((slide) => {
                    slide.style.paddingBottom = self.data.ratio_Mob * 100 + "%";
                    if (
                      slide.querySelectorAll(".slideshow-image.medium-up--hide")
                        .length > 0
                    ) {
                      slide
                        .querySelectorAll(".slideshow-image.medium-up--hide")
                        .forEach((image) => {
                          image.style.paddingBottom =
                            self.data.ratio_Mob * 100 + "%";
                        });
                    }
                  });
                if (self.data.parallax)
                  self.container.style.paddingBottom =
                    self.data.ratio * 100 + "%";
              }
            } else {
              self.container
                .querySelectorAll(".swiper-slide")
                .forEach((slide) => {
                  slide.style.paddingBottom = self.data.height_Mob + "px";
                  slide
                    .querySelectorAll(".slideshow-image")
                    .forEach((image) => {
                      image.style.paddingBottom = self.data.height_Mob + "px";
                    });
                });
              if (self.data.parallax)
                self.container.style.paddingBottom =
                  self.data.height_Mob + "px";
            }
          }
        });
      },

      media: function () {
        var self = this;
        self.swiper.on("slideChange", function (e) {
          const { slides: r, activeIndex: n } = e;
          theme.utils.pauseAllMedia();
          if (r.eq(n)[0].querySelector("template")) {
            const template = r.eq(n)[0].querySelector("template")
              .content.firstElementChild;
            if (
              (template.src ? template.src.includes("autoplay=1") : false) ||
              template.getAttribute("autoplay")
            ) {
              theme.utils.playMedia(r.eq(n)[0]);
            }
            if (r.eq(n)[0].querySelector(".shopify-model-viewer-ui"))
              self.swiper.allowTouchMove = false;
          }
        });
      },

      onBlockSelect: function (evt) {
        if (
          this.container.querySelector("#block--" + evt.detail.blockId) &&
          this.swiper
        ) {
          var block = this.container.querySelector(
            "#block--" + evt.detail.blockId
          );
          var index = parseInt(block.getAttribute("id").slice(-1));
          this.swiper.slideTo(index + 1);
        }
      },
    });

    return Swiper_Slider;
  })();

  // --- Section : Map
  theme.Map = (function () {
    function Map(container) {
      this.container = container;
      this.settings = {
        apiKey: container.getAttribute("data-api-key"),
        address: container.getAttribute("data-address"),
        mapStyle: container.getAttribute("data-map-style"),
        enablePin:
          container.getAttribute("data-enable-pin") == "true" ? true : false,
        markerColor: container.getAttribute("data-marker-color"),
      };

      this.map;

      this.init();
    }

    Map.prototype = Object.assign({}, Map.prototype, {
      init: function () {
        var self = this;
        this.map = null;
        if (
          typeof this.settings.apiKey !== "string" ||
          this.settings.apiKey === ""
        ) {
          return;
        }

        if (typeof window.google === "undefined") {
          theme.utils
            .getScript(
              "https://maps.googleapis.com/maps/api/js?key=" +
                this.settings.apiKey
            )
            .then(function () {
              self.createMap();
            });
        } else {
          self.createMap();
        }
      },

      createMap: function () {
        var self = this;
        var container = this.container;
        new Promise(function (resolve, reject) {
          var geocoder = new google.maps.Geocoder();
          geocoder.geocode(
            { address: self.settings.address },
            function (results, status) {
              if (status !== google.maps.GeocoderStatus.OK) {
                reject(status);
              } else {
                resolve(results);
              }
            }
          );
        })
          .then(function (results) {
            var style = JSON.parse(self.settings.mapStyle);

            var config = {
              zoom: 14,
              styles: style,
            };

            var mapOptions = {
              zoom: config.zoom,
              styles: config.styles,
              center: results[0].geometry.location,
              draggable: true,
              clickableIcons: true,
              scrollwheel: true,
              disableDoubleClickZoom: false,
              disableDefaultUI: false,
            };

            self.map = new google.maps.Map(container, mapOptions);
            var enablePin = self.settings.enablePin;
            var markerColor = self.settings.markerColor;
            var center = self.map.getCenter();

            var markerIcon = {
              path: "M12 0c-4.198 0-8 3.403-8 7.602 0 4.198 3.469 9.21 8 16.398 4.531-7.188 8-12.2 8-16.398 0-4.199-3.801-7.602-8-7.602zm0 11c-1.657 0-3-1.343-3-3s1.343-3 3-3 3 1.343 3 3-1.343 3-3 3z",
              fillColor: markerColor,
              fillOpacity: 0.9,
              scale: 1.5,
              strokeWeight: 0,
            };

            //eslint-disable-next-line no-unused-vars
            if (enablePin) {
              new google.maps.Marker({
                map: self.map,
                icon: markerIcon,
                position: center,
              });
            }

            google.maps.event.addDomListener(
              window,
              "resize",
              theme.utils.debounce(250, function () {
                google.maps.event.trigger(self.map, "resize");
                self.map.setCenter(center);
              })
            );
          })
          .catch(function (status) {
            var errorMessage;
            switch (status) {
              case "ZERO_RESULTS":
                errorMessage = theme.strings.addressNoResults;
                break;
              case "OVER_QUERY_LIMIT":
                errorMessage = theme.strings.addressQueryLimit;
                break;
              default:
                errorMessage = theme.strings.addressError;
                break;
            }

            // Only show error in the theme editor
            if (Shopify.designMode) {
              var mapContainer = theme.utils.getParents(
                self.container,
                "map-section"
              );
              mapContainer.classList.add("map-section--load-error");
              mapContainer.querySelector(".map-error__wrapper").innerHTML =
                '<div class="errors text-center" style="width: 100%;">' +
                errorMessage +
                "</div>";
            }
          });
      },

      onUnload: function () {
        if (typeof window.google !== "undefined" && this.map != null) {
          google.maps.event.clearListeners(this.map, "resize");
        }
      },
    });

    return Map;
  })();

  // --- Section : Gallery
  class Gallery extends HTMLElement {
    constructor() {
      super();

      this.GallerySwiper = null;
      this.modal = this.nextElementSibling;
      this.init();
    }

    init() {
      var self = this;
      let itemsButton = this.querySelectorAll(".flex-caption.fullscreen");

      if (itemsButton) {
        itemsButton.forEach((button) => {
          button.addEventListener("click", (e) => {
            if (self.GallerySwiper == null) {
              self.createSwiper(
                parseInt(button.closest(".swiper-slide").dataset.index)
              );
            }
          });
        });
      }

      this.modal.addEventListener("modalClose", this.deleteSwiper.bind(this));
    }

    createSwiper(slideToIndex) {
      const modalContent = this.modal.querySelector(
        ".gallery-media-modal__content"
      );
      modalContent.innerHTML = "";
      modalContent.appendChild(
        this.querySelector(".swiper-gallery-container").cloneNode(true)
      );
      modalContent.querySelector(".swiper").dataset.shown = 1;
      modalContent.querySelectorAll(".image-container").forEach((image) => {
        image.setAttribute("class", "image-container");
      });

      if (modalContent.querySelector(".triple-slider")) {
        modalContent.querySelector(".triple-slider-prev").remove();
        modalContent.querySelector(".triple-slider-next").remove();
        modalContent
          .querySelector(".swiper")
          .classList.remove("triple-slider-main");
      }
      this.GallerySwiper = new theme.Swiper_Slider(
        modalContent.querySelector(".swiper")
      );
      modalContent.querySelector(".swiper").swiper.slideTo(slideToIndex - 1);
    }

    deleteSwiper() {
      this.GallerySwiper.swiper.destroy();
      this.GallerySwiper = null;
    }
  }
  customElements.define("gallery-fullsize", Gallery);

  // --- Section : social-feed
  theme.Feed = (function () {
    function Feed(container) {
      this.container = container;
      this.init();
    }

    Feed.prototype = Object.assign({}, Feed.prototype, {
      init: function () {
        if (this.container.querySelector("[data-twitter]")) {
          this.twitter();
        }
        if (this.container.querySelector("[data-pinterest]")) {
          this.pinterest();
        }
        if (this.container.querySelector("[data-instagram]")) {
          this.instagram_init();
        }
      },

      twitter: function () {
        var twitterContainer = this.container.querySelector("[data-twitter]");
        var options = {
          container: twitterContainer,
          sourceType: twitterContainer.getAttribute("data-source-type"),
          name: twitterContainer.getAttribute("data-screen-name"),
          last: twitterContainer.getAttribute("data-last"),
          theme: twitterContainer.getAttribute("data-theme"),
          tweetLimit: parseInt(
            twitterContainer.getAttribute("data-tweet-limit")
          ),
        };

        var parameters = {
          theme: options.theme,
          tweetLimit: options.tweetLimit,
          chrome: "noheader nofooter",
        };

        if (options.sourceType == "profile") {
          var source = {
            sourceType: options.sourceType,
            screenName: options.name,
          };
        } else if (options.sourceType == "tweet") {
          var source = options.last;
        } else {
          var source = {
            sourceType: options.sourceType,
            ownerScreenName: options.name,
            slug: options.last,
          };
        }

        if (typeof window.twttr === "undefined") {
          window.twttr = window.twttr || {};
          window.twttr._e = [];
          window.twttr.ready = function (f) {
            window.twttr._e.push(f);
          };
          theme.utils
            .getScript("https://platform.twitter.com/widgets.js", "twitter-wjs")
            .then(function () {
              if (options.sourceType != "tweet") {
                window.twttr.widgets.createTimeline(
                  source,
                  twitterContainer,
                  parameters
                );
              } else {
                window.twttr.widgets.createTweet(
                  source,
                  twitterContainer,
                  parameters
                );
              }
            });
        } else {
          if (options.sourceType != "tweet") {
            window.twttr.widgets.createTimeline(
              source,
              twitterContainer,
              parameters
            );
          } else {
            window.twttr.widgets.createTweet(
              source,
              twitterContainer,
              parameters
            );
          }
        }
      },

      pinterest: function () {
        if (typeof window.PinUtils === "undefined") {
          !(function (a, b, c) {
            var d, e, f;
            (d = "PIN_" + ~~(new Date().getTime() / 864e5)),
              (a["PinId"] = d),
              (a[d] = 1),
              a.setTimeout(function () {
                (e = b.getElementsByTagName("SCRIPT")[0]),
                  (f = b.createElement("SCRIPT")),
                  (f.type = "text/javascript"),
                  (f.id = "pinterest-wjs"),
                  (f.async = !0),
                  (f.src = c.mainUrl + "?" + Math.random()),
                  e.parentNode.insertBefore(f, e);
              }, 10);
          })(window, document, {
            mainUrl: "https://assets.pinterest.com/js/pinit_main.js",
          });
        } else {
          document
            .querySelector(
              'script[src*="assets.pinterest.com/js/pinit_main.js"]'
            )
            .remove();
          if (document.querySelector("pinterest-wjs"))
            document.querySelector("pinterest-wjs").remove();
          !(function (a, b, c) {
            var e, f;
            (a["PinId"] = 1),
              a.setTimeout(function () {
                (e = b.getElementsByTagName("SCRIPT")[0]),
                  (f = b.createElement("SCRIPT")),
                  (f.type = "text/javascript"),
                  (f.async = !0),
                  (f.src = c.mainUrl + "?" + Math.random()),
                  e.parentNode.insertBefore(f, e);
              }, 10);
          })(window, document, {
            mainUrl: "https://assets.pinterest.com/js/pinit_main.js",
          });
        }
      },

      instagram_init: function () {
        var self = this;
        var instagramContainer =
          this.container.querySelector("[data-instagram]");
        this.loadMore =
          '<div class="instafeed-loadmore"><div class="btn--small btn">' +
          Shopify.translation.instafeed_show_more +
          "</div></div>";
        this.loader = '<div class="instafeed-loader"></div>';
        this.options = {
          container: instagramContainer,
          accountType: "graph.instagram.com/me/",
          src: instagramContainer.dataset.src,
          token_api: instagramContainer.dataset.tokenApi,
          fields: instagramContainer.dataset.fields,
          limit: parseInt(instagramContainer.dataset.limit),
          limitMob: parseInt(instagramContainer.dataset.limitMob),
          style: instagramContainer.dataset.style,
          template: instagramContainer.dataset.template,
          layout: instagramContainer.dataset.layout,
        };

        if (typeof window.insta === "undefined") {
          window.instaToken = this.options.token_api || {};

          theme.utils
            .getScript(self.options.src, "instagram-wjs")
            .then(function () {
              self.instagram_request();
            });
        } else {
          this.instagram_request();
        }
      },

      instagram_request: function () {
        var self = this;
        var feed = new Instafeed({
          accountType: self.options.accountType,
          fields: self.options.fields,
          mock: true,
          success: function (data) {
            fetch(
              `https://graph.instagram.com/refresh_access_token?grant_type=ig_refresh_token&access_token=${self.options.token_api}`
            );

            self.Instadata = data.data;
            self.limit =
              document.documentElement.clientWidth >= 781
                ? self.options.limit <= self.Instadata.length
                  ? self.options.limit
                  : self.Instadata.length
                : self.options.limitMob <= self.Instadata.length
                ? self.options.limitMob
                : self.Instadata.length;
            self.counter = Math.floor(self.Instadata.length / self.limit);
            self.left = self.Instadata.length % self.limit;
            self.count = 0;

            if (self.count <= self.counter) {
              self.instagram_render(0, self.limit);
              self.count += 1;
              if (self.options.container.querySelector(".instafeed-loadmore")) {
                self.options.container
                  .querySelector(".instafeed-loadmore")
                  .remove();
              }

              if (
                self.count < self.counter ||
                (self.left != 0 && self.counter == self.count)
              ) {
                if (self.options.layout == "grid") {
                  self.instagram_loadmore();
                } else {
                  var d = document.createElement("div");
                  d.classList.add("swiper-slide", "inline-flex");
                  self.options.container
                    .querySelector(".swiper-wrapper")
                    .appendChild(d);
                  self.InstaSlider = new theme.Swiper_Slider(
                    self.options.container.querySelector(".swiper")
                  );
                  self.instagram_slidemore();
                }
              } else {
                if (self.options.layout == "slider") {
                  self.InstaSlider = new theme.Swiper_Slider(
                    self.options.container.querySelector(".swiper")
                  );
                }
              }

              window.on(
                "resize",
                theme.utils.debounce(300, function () {
                  self.limit =
                    document.documentElement.clientWidth >= 781
                      ? self.options.limit
                      : self.options.limitMob;
                  if (self.options.layout == "grid") {
                    self.options.container.innerHTML = self.loader;
                    self.instagram_render(0, self.limit);
                    self.count = 1;
                    if (
                      self.count < self.counter ||
                      (self.left != 0 && self.counter == self.count)
                    ) {
                      self.instagram_loadmore();
                    }
                  } else {
                    self.InstaSlider.swiper.destroy();
                    self.InstaSlider = "";
                    self.count = 0;
                    var d = document.createElement("div");
                    d.classList.add("instafeed-loader");
                    self.options.container.appendChild(d);
                    self.options.container.querySelector(
                      ".swiper-wrapper"
                    ).innerHTML = "";
                    self.instagram_render(0, self.limit);
                    self.count += 1;
                    self.InstaSlider = new theme.Swiper_Slider(
                      self.options.container.querySelector(".swiper")
                    );
                    if (
                      self.count < self.counter ||
                      (self.left != 0 && self.counter == self.count)
                    ) {
                      self.InstaSlider.swiper.appendSlide(
                        '<div class="swiper-slide inline-flex"></div>'
                      );
                      self.instagram_slidemore();
                    }
                  }
                })
              );
            }
          },
        });
        feed.run();
      },

      instagram_render: function (offset, limit) {
        var self = this;
        var InnerTemplate = "";

        for (let i = offset; i < limit; i++) {
          var item = self.Instadata[i];

          var ItemTemplate = self.options.template
            .replace(/--([\s\\id.]+)--/g, item.id)
            .replace(/--([\s\\permalink.]+)--/g, item.permalink)
            .replace(/--([\s\\username.]+)--/g, item.username);

          var date = new Date(item.timestamp),
            month = Shopify.translation.date[date.getMonth()],
            year = date.getFullYear(),
            day = date.getDate();
          ItemTemplate = ItemTemplate.replace(
            /--([\s\\date.]+)--/g,
            day + " " + month + " " + year
          );

          if (self.options.fields.includes("caption")) {
            var caption = item.caption;
            var captionTroncate =
              caption.length > 30 ? caption.substring(0, 30) + "..." : caption;
            ItemTemplate = ItemTemplate.replace(
              /--([\s\\caption.]+)--/g,
              caption
            ).replace(/--([\s\\alt.]+)--/g, captionTroncate);
          }

          if (item.media_type == "VIDEO" && self.options.style == "classic") {
            ItemTemplate = ItemTemplate.replace(
              "img",
              "img style='display: none'"
            )
              .replace("insta-icon-carousel", "insta-icon-carousel hide")
              .replace(/--([\s\\media_url.]+)--/g, item.media_url);
          } else if (
            item.media_type == "VIDEO" &&
            self.options.style == "tile"
          ) {
            ItemTemplate = ItemTemplate.replace(
              "insta-icon-carousel",
              "insta-icon-carousel hide"
            )
              .replace("img", "img style='display: none'")
              .replace(/--([\s\\media_url.]+)--/g, item.media_url);
          } else if (item.media_type == "CAROUSEL_ALBUM") {
            ItemTemplate = ItemTemplate.replace(
              "video",
              "video style='display: none'"
            )
              .replace("insta-icon-video", "insta-icon-video hide")
              .replace(/--([\s\\media_url.]+)--/g, item.media_url);
          } else if (item.media_type == "IMAGE") {
            ItemTemplate = ItemTemplate.replace(
              "video",
              "video style='display: none'"
            )
              .replace("insta-icon-video", "insta-icon-video hide")
              .replace("insta-icon-carousel", "insta-icon-carousel hide")
              .replace(/--([\s\\media_url.]+)--/g, item.media_url);
          }

          if (ItemTemplate.includes("insta-post-share")) {
            var share =
              "open(this.href,'popup','width=600,height=600'); return false;";
            ItemTemplate = ItemTemplate.replace(
              /--([\s\\twitter_share.]+)--/g,
              share
            ).replace(/--([\s\\facebook_share.]+)--/g, share);
          }

          if (
            document.documentElement.clientWidth >= 781 ||
            self.options.layout == "grid"
          ) {
            InnerTemplate += ItemTemplate;
          } else {
            if (self.count == 0) {
              var d = document.createElement("div");
              d.innerHTML = ItemTemplate;
              d.classList.add("swiper-slide", "inline-flex");
              self.options.container
                .querySelector(".swiper-wrapper")
                .appendChild(d);
            } else {
              var slides =
                self.options.container.querySelectorAll(".swiper-slide");
              slides.forEach((slide) => {
                if (!slide.hasChildNodes()) {
                  slide.innerHTML = ItemTemplate;
                }
              });
            }
          }
        }

        if (self.options.layout == "grid") {
          self.options.container.querySelector(".instafeed-loader").remove();
          var d = document.createElement("div");
          d.innerHTML = InnerTemplate;
          d.classList.add("inline-flex");
          self.options.container.appendChild(d);
        } else {
          if (document.documentElement.clientWidth >= 781) {
            if (self.count == 0) {
              if (self.options.container.querySelector(".instafeed-loader"))
                self.options.container
                  .querySelector(".instafeed-loader")
                  .remove();
              var d = document.createElement("div");
              d.innerHTML = InnerTemplate;
              d.classList.add("swiper-slide", "inline-flex");
              self.options.container
                .querySelector(".swiper-wrapper")
                .appendChild(d);
            } else {
              var slides =
                self.options.container.querySelectorAll(".swiper-slide");
              slides.forEach((slide) => {
                if (!slide.hasChildNodes()) {
                  slide.innerHTML = InnerTemplate;
                }
              });
            }
          } else if (self.count == 0) {
            self.options.container.querySelector(".instafeed-loader").remove();
          }
        }

        let videos = document.querySelectorAll(".insta-post-video");
        if (videos.length > 0) {
          videos.forEach((video) => {
            //video.play();
          });
        }

        let shareContainers = document.querySelectorAll(".insta-post-share");
        if (shareContainers.length > 0) {
          document.addEventListener("click", function (e) {
            if (
              e.target.classList.contains("insta-post-share") &&
              !e.target
                .querySelector(".insta-post-share-popover")
                .classList.contains("insta-post-share-popover-open")
            ) {
              e.target
                .querySelector(".insta-post-share-popover")
                .classList.add("insta-post-share-popover-open");
            } else {
              document
                .querySelectorAll(".insta-post-share-popover-open")
                .forEach((share) => {
                  share.classList.remove("insta-post-share-popover-open");
                });
            }
          });
        }
      },

      instagram_loadmore: function () {
        var self = this;
        this.options.container.innerHTML += this.loadMore;
        var button = this.options.container.querySelector(
          ".instafeed-loadmore .btn--small"
        );
        button.addEventListener("click", function () {
          self.options.container.innerHTML += self.loader;
          var offset =
            self.limit * (self.count + 1) >= self.Instadata.length
              ? self.Instadata.length
              : self.limit * (self.count + 1);
          self.instagram_render(self.limit * self.count, offset);
          self.count += 1;
          self.options.container.querySelector(".instafeed-loadmore").remove();
          if (
            self.count <= self.counter ||
            (self.count == self.counter && self.left != 0)
          ) {
            self.instagram_loadmore();
          }
        });
      },

      instagram_slidemore: function () {
        var self = this;
        self.InstaSlider.swiper.on("slideChange", function () {
          if (
            self.count < self.counter ||
            (self.count == self.counter && self.left != 0)
          ) {
            var offset =
              self.limit * (self.count + 1) >= self.Instadata.length
                ? self.Instadata.length
                : self.limit * (self.count + 1);
            if (document.documentElement.clientWidth >= 781) {
              self.instagram_render(self.limit * self.count, offset);
              self.count += 1;
              if (
                self.count < self.counter ||
                (self.count == self.counter && self.left != 0)
              ) {
                self.InstaSlider.swiper.appendSlide(
                  '<li class="swiper-slide inline-flex"></li>'
                );
              }
            } else {
              var a = self.limit * self.count;
              for (a = self.limit * self.count; a < offset; a++) {
                if (self.count != 1 || a != self.limit * self.count) {
                  self.InstaSlider.swiper.appendSlide(
                    '<li class="swiper-slide inline-flex"></li>'
                  );
                }
                self.instagram_render(a, a + 1);
              }
              self.count += 1;
            }
          }
        });
      },

      onUnload: function () {
        this.init();
      },
    });

    return Feed;
  })();

  // --- Section : Shopping Feed Insta
  theme.ShoppingFeedInsta = (function () {
    function ShoppingFeedInsta(container) {
      this.container = container;
      var self = this;
      this.sectionId = "shopify-section-" + this.container.dataset.sectionId;
      this.swiper = null;
      this.modalSwiper = null;
      this.modal = this.container.querySelector("modal-dialog");
      this.init();

      document.addEventListener("shopify:block:select", function (e) {
        if (document.querySelector("#" + e.target.id)) {
          document.querySelector("#" + e.target.id).click();
        }
      });
    }

    ShoppingFeedInsta.prototype = Object.assign(
      {},
      ShoppingFeedInsta.prototype,
      {
        init: function () {
          var self = this;

          this.container.querySelectorAll("modal-opener").forEach((modal) => {
            modal.addEventListener("modalOpen", function (e) {
              self.renderPopup(this);
            });
          });

          this.modal.addEventListener("modalClose", function (e) {
            self.destroyPopup(this);
          });

          this.container.querySelectorAll("modal-opener").forEach((modal) => {
            modal.addEventListener("modalOpen", function (e) {
              self.renderPopup(this);
            });
          });
        },

        renderPopup: function (modalContent) {
          var self = this;
          var slides = modalContent.querySelector(
            ".content--products-container"
          );
          var image = modalContent.querySelector(
            ".content--wrapper > .image-container"
          );
          var postLink = modalContent
            .querySelector("article")
            .getAttribute("data-post-link");
          var username = modalContent.querySelector(
            ".content--text span"
          ).innerHTML;
          var pins = modalContent.querySelector(".shopping__pins");
          if (
            self.modal.querySelector(
              ".modal-products-caption__content .shopping__pins"
            )
          )
            self.modal
              .querySelector(".modal-products-caption__content .shopping__pins")
              .remove();

          self.modal.querySelector(".image-container").innerHTML =
            image.innerHTML;
          self.modal.querySelector(".modal-products-caption__info-name").href =
            postLink;
          self.modal.querySelector(
            ".modal-products-caption__info-name span"
          ).innerHTML = username;
          self.modal.querySelector(".swiper-wrapper").innerHTML =
            slides.innerHTML;

          self.modalSwiper = new theme.Swiper_Slider(
            self.modal.querySelector(".swiper")
          );
          self.modal.querySelector(".modal-loading").style.display = "none";

          if (pins) {
            self.modal
              .querySelector(".modal-products-caption__content")
              .appendChild(pins.cloneNode(true));
            var modal_pins = self.modal.querySelectorAll(
              ".modal-products-caption__content .product-pin"
            );
            modal_pins.forEach((pin) => {
              pin.addEventListener("click", function () {
                self.modalSwiper.swiper.slideTo(
                  this.getAttribute("data-product") - 1
                );
              });
            });
          }
        },

        destroyPopup: function () {
          var self = this;
          if (self.modalSwiper != null) {
            self.modalSwiper.swiper.destroy();
            self.modal.querySelector(".swiper-wrapper").innerHTML = "";
            self.modal.querySelector(".image-container > *").remove();
          }
          self.modalSwiper = null;
          self.modal.querySelector(".modal-loading").style.display = "";
        },
      }
    );

    return ShoppingFeedInsta;
  })();

  // --- Section : Product Recommendations
  theme.ProductRecommendations = (function () {
    function ProductRecommendations(container) {
      this.container = container;
      this.productId = this.container.getAttribute("data-product-id");
      this.baseUrl = this.container.getAttribute("data-base-url");
      this.limit = parseInt(this.container.getAttribute("data-limit"));

      this.getRecommendations();
    }

    ProductRecommendations.prototype = Object.assign(
      {},
      ProductRecommendations.prototype,
      {
        getRecommendations() {
          var self = this;
          var recommendationsSectionUrl =
            this.baseUrl +
            "?section_id=main-product-recommendations&product_id=" +
            this.productId +
            "&limit=" +
            this.limit;
          fetch(recommendationsSectionUrl)
            .then((response) => response.text())
            .then((responseText) => {
              const html = new DOMParser().parseFromString(
                responseText,
                "text/html"
              );
              const destination = self.container.querySelector(
                ".product-recommendations"
              );
              const source = html.querySelector(".product-recommendations");
              if (source && destination)
                destination.innerHTML = source.innerHTML;
              destination.querySelectorAll("img").forEach((image) => {
                image.classList.add("visible");
              });

              if (
                self.container.querySelector(".product-recommendations .swiper")
              ) {
                new theme.Swiper_Slider(
                  self.container.querySelector(
                    ".product-recommendations .swiper"
                  )
                );
              }
            });
        },
      }
    );

    return ProductRecommendations;
  })();

  // --- Section : main-page-order-tracker
  theme.Tracking = (function () {
    function Tracking(container) {
      this.container = container;
      this.init();
    }

    Tracking.prototype = Object.assign({}, Tracking.prototype, {
      init: function () {
        if (this.container.classList.contains("tracking-more")) {
          const form = this.container.querySelector("form");
          if (
            form.querySelector('[name="button_tracking_number"]').value != ""
          ) {
            window.open("_blank").location = `${form.getAttribute("action")}/${
              form.querySelector('[name="button_tracking_number"]').value
            }?express=${
              form.querySelector('[name="express_code"]').value
            }&lang=${form.querySelector('[name="lang"]').value}`;
          } else {
            form.addEventListener("submit", function (e) {
              e.preventDefault();
              e.stopPropagation();
              window.open("_blank").location = `${form.getAttribute(
                "action"
              )}/${
                form.querySelector('[name="button_tracking_number"]').value
              }?express=${
                form.querySelector('[name="express_code"]').value
              }&lang=${form.querySelector('[name="lang"]').value}`;
            });
          }
        }
      },
    });

    return Tracking;
  })();

  theme.TrackingGenie = (function () {
    function TrackingGenie(container) {
      this.container = container;
      this.init();
    }

    TrackingGenie.prototype = Object.assign({}, TrackingGenie.prototype, {
      init: function () {
        var self = this;

        var options = {
          minDays: parseInt(this.container.getAttribute("data-min-days")),
          maxDays: parseInt(this.container.getAttribute("data-max-days")),
          preparation: this.container.getAttribute("data-preparation"),
          text_preparation: this.container.getAttribute(
            "data-text-preparation"
          ),
          bg_preparation: this.container.getAttribute("data-bg-preparation"),
          on_way: this.container.getAttribute("data-on-way"),
          text_on_way: this.container.getAttribute("data-text-on-way"),
          bg_on_way: this.container.getAttribute("data-bg-on-way"),
          late: this.container.getAttribute("data-late"),
          text_late: this.container.getAttribute("data-text-late"),
          bg_late: this.container.getAttribute("data-bg-late"),
          submit: this.container.querySelector('button[type="submit"]'),
          formError: this.container.querySelector("#track-error"),
          loadingBar: self.container.querySelector(".loading-bar"),
          statusTitle: self.container.querySelector(".status span"),
          statusText: self.container.querySelector(".text-status"),
          firstDateText: self.container.querySelector("#firstDate"),
          lastDateText: self.container.querySelector("#lastDate"),
        };

        options.submit.addEventListener("click", function () {
          if (
            self.container.querySelector('input[type="text"]').value.trim ==
              "" ||
            !self.container.querySelector('input[type="date"]').value
          ) {
            options.formError.show();
          } else {
            var inputDate =
              self.container.querySelector('input[type="date"]').value;
            var inputDateFormat = new Date(inputDate);
            var dayNow = new Date();

            if (inputDateFormat > dayNow) {
              return;
            }

            inputDate = inputDate.replace(/-/g, ",");
            var today = new Date(),
              dd = String(today.getDate()).padStart(2, "0"),
              mm = String(today.getMonth() + 1).padStart(2, "0"),
              yyyy = today.getFullYear();
            today = yyyy + "," + mm + "," + dd;

            var oneDay = 24 * 60 * 60 * 1000,
              firstDate = new Date(inputDate),
              secondDate = new Date(today),
              diffDays = Math.round(
                Math.abs((firstDate.getTime() - secondDate.getTime()) / oneDay)
              );

            function getDeliveryDates(averageNumber) {
              var averageDeliveryTimeMin =
                  options.minDays + options.maxDays - 5,
                averageDeliveryTimeMax =
                  options.minDays + options.maxDays + averageNumber,
                minDeliveryDate = self.addDays(
                  inputDateFormat,
                  averageDeliveryTimeMin
                ),
                maxDeliveryDate = self.addDays(
                  inputDateFormat,
                  averageDeliveryTimeMax
                ),
                minDay = minDeliveryDate.getDate(),
                minMonth = minDeliveryDate.getMonth() + 1,
                minYear = minDeliveryDate.getFullYear(),
                maxDay = maxDeliveryDate.getDate(),
                maxMonth = maxDeliveryDate.getMonth() + 1,
                maxYear = maxDeliveryDate.getFullYear();

              if (minDay < 10) {
                minDay = "0" + minDay;
              }
              if (minMonth < 10) {
                minMonth = "0" + minMonth;
              }
              if (maxDay < 10) {
                maxDay = "0" + maxDay;
              }
              if (maxMonth < 10) {
                maxMonth = "0" + maxMonth;
              }

              options.firstDateText.innerHTML =
                minDay + "/" + minMonth + "/" + minYear;
              options.lastDateText.innerHTML =
                maxDay + "/" + maxMonth + "/" + maxYear;
              self.container.querySelector(".tracking").style.display = "";
            }

            if (diffDays < options.minDays) {
              options.loadingBar.classList.add("loading-bar-grey");
              options.loadingBar.style.background = options.bg_preparation;
              options.statusTitle.innerHTML = options.preparation;
              options.statusText.innerHTML = options.text_preparation;
              getDeliveryDates(5);
            } else if (
              diffDays >= options.minDays &&
              diffDays < options.maxDays
            ) {
              options.loadingBar.classList.remove("loading-bar-grey");
              options.loadingBar.style.background = options.bg_on_way;
              options.statusTitle.innerHTML = options.on_way;
              options.statusText.innerHTML = options.text_on_way;
              getDeliveryDates(5);
            } else {
              options.loadingBar.classList.remove("loading-bar-grey");
              options.loadingBar.style.background = options.bg_late;
              options.statusTitle.innerHTML = options.late;
              options.statusText.innerHTML = options.text_late;
              getDeliveryDates(10);
            }
          }
        });
      },

      addDays: function (date, days) {
        var result = new Date(date);
        result.setDate(result.getDate() + days);
        return result;
      },
    });

    return TrackingGenie;
  })();

  /* --- App: Back to top */
  class BacktoTop extends HTMLElement {
    constructor() {
      super();

      var self = this;

      window.pageYOffset != 0
        ? this.classList.add("fadeIn")
        : this.classList.add("fadeOut");

      this.addEventListener("click", function () {
        theme.utils.scrollToSmoothly(0, 500);
      });

      window.addEventListener("scroll", function () {
        window.pageYOffset != 0
          ? (self.classList.add("fadeIn"), self.classList.remove("fadeOut"))
          : (self.classList.add("fadeOut"), self.classList.remove("fadeIn"));
      });
    }
  }
  customElements.define("back-top", BacktoTop);

  /* --- Product Card Slider product media */
  class productCardSlider extends HTMLElement {
    constructor() {
      super();

      const images = this.dataset.images.split(",");
      const card = this.closest(".product-card");
      const imageContainer = card.querySelector("img.first");
      let x,
        self = this;
      if (images.length > 1) {
        card.addEventListener("mouseenter", () => {
          let count = 1;
          imageContainer.src = images[count];
          imageContainer.srcset = images[count];
          count++;
          if (count >= images.length) count = 0;

          x = setInterval(() => {
            imageContainer.src = images[count];
            imageContainer.srcset = images[count];
            count++;
            if (count >= images.length) count = 0;
          }, 1000);
        });

        card.addEventListener("mouseleave", () => {
          clearInterval(x);
          imageContainer.srcset = images[0];
          imageContainer.src = images[0];
        });
      }
    }
  }
  customElements.define("product-card-slider", productCardSlider);

  /* --- App : Color swatches */
  class colorSwatches extends HTMLElement {
    constructor() {
      super();
      if (document.documentElement.clientWidth > 779) {
        var self = this;
        var parent =
          theme.utils.getParents(this, "product-card") != false
            ? theme.utils.getParents(this, "product-card")
            : theme.utils.getParents(this, "product-single");
        this.querySelectorAll(".swatch:not(.see-more-swatch) span").forEach(
          (swatch) => {
            swatch.addEventListener("mouseenter", function () {
              if (swatch.getAttribute("data-image").indexOf("no-image") == -1) {
                parent.querySelectorAll("img")[0].src = parent.querySelectorAll(
                  "img"
                )[0].srcset = swatch.getAttribute("data-image");
                if (parent.querySelector("img.secondary")) {
                  parent.querySelector("img.secondary").src =
                    parent.querySelector("img.secondary").srcset =
                      swatch.getAttribute("data-image");
                }
              }
            });

            swatch.addEventListener("mouseleave", function () {
              if (
                self
                  .querySelectorAll(".swatch span")[0]
                  .getAttribute("data-image")
                  .indexOf("no-image") == -1
              ) {
                parent.querySelectorAll("img")[0].src = parent.querySelectorAll(
                  "img"
                )[0].srcset = self
                  .querySelectorAll(".swatch span")[0]
                  .getAttribute("data-image");
              }
              if (
                parent.querySelector("img.secondary") &&
                self
                  .querySelectorAll(".swatch span")[1]
                  .getAttribute("data-image")
                  .indexOf("no-image") == -1
              ) {
                parent.querySelector("img.secondary").src =
                  parent.querySelector("img.secondary").srcset = self
                    .querySelectorAll(".swatch span")[1]
                    .getAttribute("data-image");
              }
            });
          }
        );
      }
    }
  }
  customElements.define("color-swatches", colorSwatches);

  /* --- Function: Deferred Media */
  class DeferredMedia extends HTMLElement {
    constructor() {
      super();
      var self = this;
      if (this.querySelector('[id^="Deferred-Poster-"]')) {
        if (this.querySelector("span.deferred-media__poster-button")) {
          this.querySelector('[id^="Deferred-Poster-"]').addEventListener(
            "click",
            () => {
              self.dataset.toplay = true;
              self.loadContent();
            }
          );
        } else {
          this.loadContent();
        }
      }
    }

    loadContent() {
      if (!this.getAttribute("loaded")) {
        this.appendChild(
          this.querySelector("template").content.firstElementChild.cloneNode(
            true
          )
        );
        this.setAttribute("loaded", true);
      }
      if (this.dataset.toplay) this.playContent();
    }

    playContent() {
      if (
        this.querySelector(".js-youtube") &&
        (this.dataset.toplay ||
          this.querySelector(".js-youtube").src.includes("autoplay=1"))
      ) {
        this.querySelector(".js-youtube").contentWindow.postMessage(
          '{"event":"command","func":"' + "playVideo" + '","args":""}',
          "*"
        );
      } else if (
        this.querySelector(".js-vimeo") &&
        (this.dataset.toplay ||
          this.querySelector(".js-vimeo").src.includes("autoplay=1"))
      ) {
        this.querySelector(".js-vimeo").contentWindow.postMessage(
          '{"method":"play"}',
          "*"
        );
      } else if (
        this.querySelector("video") &&
        (this.dataset.toplay ||
          this.querySelector("video").getAttribute("autoplay"))
      ) {
        this.querySelector("video").play();
      } else if (this.querySelector(".shopify-model-viewer-ui model-viewer")) {
        var model = this.querySelector("product-model");
        if (model.modelViewerUI) {
          model.modelViewerUI.play();
        }
      }

      if (this.querySelector("span.deferred-media__poster-button")) {
        this.querySelector("span.deferred-media__poster-button").style.display =
          "none";
        if (this.closest(".swiper.swiper-initialized").length > 0) {
          this.closest(
            ".swiper.swiper-initialized"
          ).swiper.allowTouchMove = false;
        }
      }
    }
  }
  customElements.define("deferred-media", DeferredMedia);

  /* --- Function: Link Collapsing */
  class LinkCollapsing extends HTMLElement {
    constructor() {
      super();

      var self = this;
      this.enableMobile = this.getAttribute("data-mobile-only") ? true : false;
      this.mobile =
        this.getAttribute("data-mobile-only") == "true" ? true : false;

      this.checkCollapse(this);

      if (this.mobile) {
        window.on(
          "resize",
          theme.utils.debounce(300, function () {
            self.checkCollapse(self);
          })
        );
      }

      document.addEventListener(
        "reloadfilter",
        theme.utils.debounce(300, function () {
          self.checkCollapse(self);
        })
      );

      document.addEventListener("shopify:section:load", self.checkCollapse);
    }

    checkCollapse(self) {
      this.link = this.querySelector(".link_collapsing_title");
      this.content = theme.utils.next(this.link, ".link_collapsing_content");
      if (
        (document.documentElement.clientWidth < 500 && this.mobile) ||
        !this.mobile
      ) {
        if (this.enableMobile) {
          this.content.style.display = "none";
          if (this.content.classList.contains("active"))
            this.content.classList.remove("active");
          if (this.link.classList.contains("active"))
            this.link.classList.remove("active");
        }

        this.link.addEventListener("click", this.collapsing, true);

        if (document.querySelector(".link_collapsing_all_button")) {
          document
            .querySelector(".link_collapsing_all_button")
            .addEventListener("click", function () {
              this.closest("div")
                .querySelectorAll(".link_collapsing_title")
                .forEach((link) => {
                  link.classList.remove("active");
                  theme.utils
                    .next(link, ".link_collapsing_content")
                    .classList.remove("active");
                  theme.utils.next(
                    link,
                    ".link_collapsing_content"
                  ).style.display = "none";
                });
            });
        }
      } else {
        self.link.removeEventListener("click", self.collapsing, true);
        self.content.style.display = "";
        if (!self.content.classList.contains("active"))
          self.content.classList.add("active");
        if (!self.link.classList.contains("active"))
          self.link.classList.add("active");
      }
    }

    collapsing() {
      this.classList.toggle("active");
      var content = theme.utils.next(this, ".link_collapsing_content");
      content.classList.toggle("active");
      theme.utils.slideToggle(content, 200);
    }
  }
  customElements.define("link-collapsing", LinkCollapsing);

  /* --- Function: Link Collapsing */
  class ReadMore extends HTMLElement {
    constructor() {
      super();

      var self = this;
      this.content = theme.utils.next(this, ".read_more_content");

      if (this.content) {
        this.addEventListener(
          "click",
          theme.utils.throttle(function () {
            self.classList.toggle("active");
            self.content.classList.toggle("active");
            theme.utils.slideToggle(self.content, 200);
          }, 300)
        );
      }
    }
  }
  customElements.define("read-more", ReadMore);

  /* --- Function: Localization */
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();

      var self = this;
      this.querySelectorAll("a").forEach((item) =>
        item.addEventListener("click", this.onItemClick.bind(this))
      );

      document.addEventListener("click", function (e) {
        if (!self.querySelector("details").contains(e.target)) {
          self.querySelector("details").removeAttribute("open");
        } else {
          !self.querySelector("details").contains(e.target)
            ? self.querySelector("details").removeAttribute("open")
            : "";
        }
      });
    }

    onItemClick(event) {
      event.preventDefault();
      event.stopPropagation();
      const form = event.currentTarget.closest("form");
      const input = event.currentTarget
        .closest("ul")
        .querySelector("input[data-localization]");
      input.value = event.currentTarget.dataset.value;
      if (form) {
        form.submit();
      }
    }
  }
  customElements.define("localization-form", LocalizationForm);

  /* --- Function: Modal Dialog */
  class ModalDialog extends HTMLElement {
    constructor() {
      super();

      var self = this;

      if (this.querySelector('[id^="ModalClose-"]')) {
        this.querySelector('[id^="ModalClose-"]').addEventListener(
          "click",
          this.hide.bind(this)
        );
      }

      this.addEventListener("click", (event) => {
        if (event.target.nodeName === "MODAL-DIALOG") this.hide();
      });

      document.addEventListener("shopify:section:load", () => {
        if (
          self.dataset.stayReload &&
          self.dataset.stayReload == "false" &&
          self.getAttribute("open")
        ) {
          self.hide();
        }
      });
    }

    show(opener, overflow = true) {
      this.openedBy = opener;
      this.setAttribute("open", "");
      this.dispatchEvent(new CustomEvent("modalOpen"));

      if (overflow) {
        (document.body.style.top = `-${window.pageYOffset}px`),
          document.body.classList.add("overflow-hidden-fixed");
      }

      if (this.querySelector(".template-popup")) {
        this.querySelector(".template-popup").loadContent();
      }
    }

    hide() {
      (this.scrollY = document.body.style.top),
        (document.body.style.top = ""),
        document.body.classList.remove("overflow-hidden-fixed"),
        this.removeAttribute("open");
      window.scrollTo({
        left: 0,
        top: parseInt(this.scrollY || "0") * -1,
        behavior: "instant",
      });
      this.dispatchEvent(new CustomEvent("modalClose"));
    }
  }
  customElements.define("modal-dialog", ModalDialog);

  /* --- Function: Modal Opener */
  class ModalOpener extends HTMLElement {
    constructor() {
      super();

      this.eventOpen = new CustomEvent("modalOpen");

      const self = this;

      if (this.getAttribute("data-button") == "true") {
        const button = this.querySelector("button");
        if (button) {
          button.addEventListener("click", () => {
            this.dispatchEvent(this.eventOpen);
            document
              .querySelector(this.getAttribute("data-modal"))
              .show(button);
          });
        }
      } else {
        this.addEventListener("click", () => {
          this.dispatchEvent(this.eventOpen);
          document.querySelector(this.getAttribute("data-modal")).show(self);
        });
      }
    }
  }
  customElements.define("modal-opener", ModalOpener);

  /* --- Function: Parallax */
  class Parallax extends HTMLElement {
    constructor() {
      super();

      if (
        this.closest(".swiper") &&
        this.closest(".swiper-wrapper").querySelectorAll(".swiper-slide")
          .length > 1
      ) {
        var image = this.querySelector("img");
        new simpleParallax(image, {
          orientation: "down",
          scale: 1.4,
        });
      } else {
        if (this.closest(".swiper"))
          this.closest(".swiper").classList.add("parallax");
        this.closest(".image-container").classList.add("image-parallax");
        this.closest(".image-container").innerHTML = this.innerHTML;
      }
    }
  }
  if (!customElements.get("image-parallax")) {
    customElements.define("image-parallax", Parallax);
  }

  /* --- Section Search */
  class SearchForm extends HTMLElement {
    constructor() {
      super();

      var self = this;

      this.querySelector("form").addEventListener("submit", function (e) {
        e.preventDefault();
        e.stopPropagation();
      });

      this.querySelector("input").addEventListener(
        "input",
        theme.utils.throttle(function () {
          setTimeout(function () {
            self.getSearch();
          }, 300);
        }, 300)
      );
    }

    getSearch() {
      const pagination = this.closest("section").querySelector(
        ".collection_pagination"
      );
      const resultsText =
        this.closest("section").querySelector(".search_results");
      const resultsGrid =
        this.closest("section").querySelector("#productsGrid");
      const resultsContent =
        this.closest("section").querySelector("#productsGrid");

      resultsGrid.classList.add("loading");
      resultsContent.innerHTML = "";

      let form = this.querySelector("form");
      const formSerialize = JSON.parse(theme.utils.serializeForm(form));

      fetch(
        form.getAttribute("action") +
          "?q=" +
          formSerialize.q +
          "&options%5Bprefix%5D=last",
        { ...theme.utils.fetchConfig("javascript") }
      )
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(
            responseText,
            "text/html"
          );

          const Source_pagination = html.querySelector(
            ".collection_pagination"
          );
          const Source_resultsText = html.querySelector(".search_results");
          const Source_resultsContent = html.querySelector("#productsGrid");

          if (Source_pagination && pagination)
            pagination.innerHTML = Source_pagination.innerHTML;
          if (Source_resultsText && resultsText)
            resultsText.innerHTML = Source_resultsText.innerHTML;
          if (Source_resultsContent && resultsContent)
            resultsContent.innerHTML = Source_resultsContent.innerHTML;
          resultsGrid.classList.remove("loading");
          resultsGrid.classList.remove("hide");
        });
    }
  }
  customElements.define("search-form", SearchForm);

  /* --- Product form */
  class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector("form");
      if (this.form) {
        this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
      }
    }

    onSubmitHandler(evt) {
      evt.preventDefault();

      const submitButton = this.querySelector('[type="submit"]');

      submitButton.setAttribute("disabled", true);
      submitButton.classList.add("loading");
      submitButton.style.overflow = "hidden";
      const content = submitButton.innerHTML;
      submitButton.innerHTML = "";
      submitButton.innerHTML += Shopify.theme_settings.loader;

      if (document.querySelectorAll(".cart-bubble")) {
        document.querySelectorAll(".cart-bubble").forEach((bubble) => {
          bubble.innerHTML = Shopify.theme_settings.loader;
        });
      }

      const body = new FormData(this.form);

      fetch(`${this.form.getAttribute("action")}`, {
        method: "post",
        body: body,
      })
        .then(function () {
          if (
            Shopify.theme_settings.atc_action == "cart" &&
            window.location.href.indexOf("cart") == -1
          ) {
            window.location.href = "/cart";
            return;
          } else if (Shopify.theme_settings.atc_action == "checkout") {
            window.location.href = "/checkout";
            return;
          }

          document.dispatchEvent(new CustomEvent("updateCart"));

          if (document.querySelectorAll(".cart-bubble")) {
            fetch("/cart.js", { ...theme.utils.fetchConfig("javascript") })
              .then((cart) => cart.json())
              .then(function (cart) {
                document.querySelectorAll(".cart-bubble").forEach((bubble) => {
                  bubble.classList.remove("hide");
                  bubble.innerHTML = cart.item_count;
                });
              });
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          submitButton.innerHTML = Shopify.theme_settings.itemAdd;
          if (Shopify.theme_settings.itemAddIcon == "itemAdd--cart-filling") {
            !(function (s, i, u, o, c, w, d, t, n, x, e, p) {
              w[o] = w[o] || {};
              w[o][s] = w[o][s] || [];
              w[o][s].push(i);
              e = d.createElementNS(n, t);
              e.async = true;
              e.setAttributeNS(
                x,
                "href",
                [u, s, ".", "j", "s", "?", "v", "=", c].join("")
              );
              e.setAttributeNS(null, "src", [u, s, ".", "j", "s"].join(""));
              p = d.getElementsByTagName(t)[0];
              p.parentNode.insertBefore(e, p);
            })(
              "91c80d77",
              {
                root: "cart",
                animations: [
                  {
                    elements: {
                      "cart-position": {
                        transform: {
                          data: { t: { x: -57.266433, y: -64.045 } },
                          keys: {
                            o: [
                              {
                                t: 700,
                                v: { x: 57.266434, y: 64.045, type: "corner" },
                                e: [0.42, 0, 0.395, 1.005],
                              },
                              {
                                t: 1000,
                                v: { x: 52.287184, y: 64.045, type: "corner" },
                                e: [0.55, 0.055, 0.935, 0.355],
                              },
                              {
                                t: 1400,
                                v: { x: 97, y: 64.045, type: "corner" },
                              },
                              {
                                t: 1410,
                                v: { x: 8.25, y: 64.045, type: "corner" },
                                e: [0.215, 0.61, 0.355, 1],
                              },
                              {
                                t: 1900,
                                v: { x: 65.71, y: 64.045, type: "corner" },
                                e: [0.58, 0, 0.58, 1],
                              },
                              {
                                t: 2100,
                                v: { x: 57.266434, y: 64.045, type: "corner" },
                                e: [0.42, 0, 0.395, 1.005],
                              },
                            ],
                            k: [
                              {
                                t: 1000,
                                v: { x: 0, y: 0 },
                                e: [0.42, 0, 1, 1],
                              },
                              { t: 1400, v: { x: -4, y: 0 } },
                              {
                                t: 1900,
                                v: { x: -8, y: 0 },
                                e: [0.58, 0, 0.58, 1],
                              },
                              { t: 2100, v: { x: 0, y: 0 } },
                            ],
                          },
                        },
                        opacity: [
                          { t: 1200, v: 1 },
                          { t: 1400, v: 0 },
                          { t: 1410, v: 0 },
                          { t: 1700, v: 1 },
                        ],
                      },
                      "cart-line1": {
                        "#line": [
                          {
                            t: 700,
                            v: [76, 92, 66, 92],
                            e: [0.42, 0, 0.395, 1.005],
                          },
                          { t: 1000, v: [77.659926, 92, 73.072594, 92] },
                          { t: 1500, v: [76, 92, 66, 92] },
                        ],
                      },
                      "cart-line2": {
                        "stroke-dashoffset": [
                          { t: 700, v: 54, e: [0.42, 0, 0.395, 1.005] },
                          { t: 1090, v: 54 },
                          { t: 1250, v: 26 },
                          { t: 1400, v: 26 },
                          { t: 1410, v: 54, e: [0.42, 0, 0.395, 1.005] },
                        ],
                        "stroke-dasharray": [
                          {
                            t: 700,
                            v: [10.8, 16.3],
                            e: [0.42, 0, 0.395, 1.005],
                          },
                          { t: 1090, v: [14.8, 12.3] },
                          { t: 1250, v: [0.1, 26.9] },
                          { t: 1400, v: [0.1, 26.9] },
                          {
                            t: 1410,
                            v: [10.8, 16.3],
                            e: [0.42, 0, 0.395, 1.005],
                          },
                        ],
                      },
                      "cart-line3": {
                        opacity: [
                          { t: 1090, v: 0 },
                          { t: 1100, v: 1 },
                        ],
                        "stroke-dashoffset": [
                          { t: 1210, v: 54, e: [0.42, 0, 0.395, 1.005] },
                          { t: 1370, v: 26 },
                        ],
                        "stroke-dasharray": [
                          {
                            t: 1210,
                            v: [10.8, 16.3],
                            e: [0.42, 0, 0.395, 1.005],
                          },
                          { t: 1370, v: [0.1, 26.9] },
                        ],
                      },
                      "cart-cart": {
                        transform: {
                          data: {
                            o: { x: 54, y: 86, type: "corner" },
                            t: { x: -54, y: -86 },
                          },
                          keys: {
                            r: [
                              { t: 700, v: 0, e: [0.42, 0, 0.395, 1.005] },
                              { t: 1000, v: -12.139813, e: [0, 0, 0.58, 1] },
                              { t: 1500, v: 0 },
                            ],
                          },
                        },
                      },
                      "cart-basket": {
                        transform: {
                          data: { t: { x: -63.999994, y: -70 } },
                          keys: {
                            o: [
                              {
                                t: 500,
                                v: { x: 63.999999, y: 70, type: "corner" },
                                e: [0.42, 0, 0.58, 1],
                              },
                              {
                                t: 700,
                                v: { x: 63.999999, y: 73, type: "corner" },
                                e: [0.42, 0, 0.58, 1],
                              },
                              {
                                t: 900,
                                v: { x: 63.999999, y: 70, type: "corner" },
                              },
                            ],
                            s: [
                              {
                                t: 500,
                                v: { x: 1, y: 1.03856 },
                                e: [0.42, 0, 0.58, 1],
                              },
                              {
                                t: 700,
                                v: { x: 1, y: 1 },
                                e: [0.42, 0, 0.58, 1],
                              },
                              { t: 900, v: { x: 1, y: 1.03856 } },
                            ],
                          },
                        },
                      },
                      "cart-item": {
                        transform: {
                          keys: {
                            o: [
                              {
                                t: 0,
                                v: {
                                  x: 58.451563,
                                  y: -9.189857,
                                  type: "corner",
                                },
                                e: [0.42, 0, 1, 1],
                              },
                              {
                                t: 500,
                                v: { x: 58.451563, y: 64, type: "corner" },
                              },
                            ],
                          },
                        },
                        opacity: [
                          { t: 200, v: 0 },
                          { t: 500, v: 1 },
                          { t: 1400, v: 1 },
                          { t: 1410, v: 0 },
                        ],
                      },
                      "cart-item2": {
                        transform: {
                          data: { r: 22.920169, t: { x: -7.0125, y: -7.0125 } },
                          keys: {
                            o: [
                              {
                                t: 100,
                                v: {
                                  x: 71.766419,
                                  y: -9.189857,
                                  type: "corner",
                                },
                                e: [0.42, 0, 1, 1],
                              },
                              {
                                t: 600,
                                v: { x: 71.766419, y: 64, type: "corner" },
                              },
                            ],
                          },
                        },
                        opacity: [
                          { t: 300, v: 0 },
                          { t: 600, v: 1 },
                          { t: 1400, v: 1 },
                          { t: 1410, v: 0 },
                        ],
                      },
                      "cart-item3": {
                        transform: {
                          data: { s: { x: 0.761249, y: 0.761249 } },
                          keys: {
                            o: [
                              {
                                t: 200,
                                v: {
                                  x: 66.576563,
                                  y: -9.189857,
                                  type: "corner",
                                },
                                e: [0.42, 0, 1, 1],
                              },
                              {
                                t: 700,
                                v: { x: 66.576563, y: 64, type: "corner" },
                              },
                            ],
                          },
                        },
                        opacity: [
                          { t: 400, v: 0 },
                          { t: 700, v: 1 },
                          { t: 1400, v: 1 },
                          { t: 1410, v: 0 },
                        ],
                      },
                    },
                    s: "MDJA1M2E1QTRjOOGU5ZjljOGI5VZTkzRTk5OTgC0YzY0NWRHNWHE1YTVhNTY0YEzhlOTM5YzhmYOGQ5ZTkzOTkB5ODRjNjQ1YjQU2NGM5MzllOLGY5YzhiOWU5VMzk5OTg5ZDRLjNjQ1YTU2NGKM5MDkzOTY5NEjRjNjQ1YjU2KNGM4Yjk2OWVADOGY5Yzk4OGTI5ZThmNGM2NMDkwOGI5NjlkSOGY1NjRjOWQF5YThmOGY4ZTKRjNjQ1YmE3",
                  },
                ],
                options:
                  "MDLAxMDhiMzI4MIzg0NzE4Mjg0PMzI0YTMyN2MD3ZjcxNzQzMjMhk",
              },
              "https://cdn.svgator.com/ply/",
              "__SVGATOR_PLAYER__",
              "2021-10-11",
              window,
              document,
              "script",
              "http://www.w3.org/2000/svg",
              "http://www.w3.org/1999/xlink"
            );
          }

          setTimeout(function () {
            if (submitButton.closest(".up-sell__product")) {
              submitButton
                .closest(".up-sell__product")
                .classList.add("fadeOutLeft");
              submitButton
                .closest(".up-sell__product")
                .classList.add("animated");
              setTimeout(function () {
                submitButton.closest(".up-sell__product").remove();
              }, 1000);
            } else {
              submitButton.style.overflow = "";
              submitButton.innerHTML = content;
              submitButton.classList.remove("loading");
              submitButton.removeAttribute("disabled");
              if (submitButton.closest("modal-dialog"))
                submitButton.closest("modal-dialog").hide();
            }
          }, 2500);
        });
    }
  }
  customElements.define("product-form", ProductForm);

  /* --- App: Cross sell pack */
  class BundleProducts extends HTMLElement {
    constructor() {
      super();

      var self = this;

      this.button = this.querySelector('button.btn--atc[type="submit"]');
      if (this.button)
        this.button.addEventListener("click", this.onSubmitHandler.bind(this));

      this.querySelectorAll("select.cart__selector-variant").forEach(
        (select) => {
          select.addEventListener("change", function (e) {
            e.preventDefault();
            this.closest("details").removeAttribute("open");
            self.updateVariants(this, this[this.selectedIndex]);
          });
        }
      );

      var details = [...this.querySelectorAll("details")];
      document.addEventListener("click", function (e) {
        if (!details.some((f) => f.contains(e.target))) {
          details.forEach((f) => f.removeAttribute("open"));
        } else {
          details.forEach((f) =>
            !f.contains(e.target) ? f.removeAttribute("open") : ""
          );
        }
      });
    }

    updateVariants(selector, option) {
      var variant = selector.closest(".bundle__products-product");
      variant.setAttribute("data-price", parseInt(option.dataset.variantPrice));
      variant.querySelector(".bundle_products__variants span").innerHTML =
        option.dataset.variantTitle;
      variant.querySelector("img").src = variant.querySelector("img").srcset =
        option.dataset.variantImage;
      this.updatePrice();
    }

    updatePrice() {
      let total_price = 0;
      this.querySelectorAll("[data-price]").forEach((product) => {
        total_price += parseInt(product.dataset.price);
      });

      total_price =
        total_price *
        ((100 - parseInt(this.querySelector("[data-save]").dataset.save)) /
          100);

      this.querySelector(".bundle_products_total").innerHTML =
        theme.Currency.formatMoney(total_price);
    }

    onSubmitHandler() {
      const submitButton = this.querySelector('button.btn--atc[type="submit"]');
      submitButton.setAttribute("disabled", true);
      submitButton.classList.add("loading");
      submitButton.style.overflow = "hidden";
      const content = submitButton.innerHTML;
      submitButton.innerHTML = "";
      submitButton.innerHTML += Shopify.theme_settings.loader;

      if (document.querySelectorAll(".cart-bubble")) {
        document.querySelectorAll(".cart-bubble").forEach((bubble) => {
          bubble.innerHTML = Shopify.theme_settings.loader;
        });
      }

      let formData = { items: [] };

      this.querySelectorAll(".bundle__products-product").forEach((product) => {
        let product_id = product.querySelector("select[data-product-bundle-id]")
          ? product.querySelector("select[data-product-bundle-id]").value
          : product.querySelector("[data-product-bundle-id]").dataset
              .productBundleId;
        formData["items"].push({ id: product_id, quantity: 1 });
      });

      const body = JSON.stringify(formData);

      fetch(`${theme.routes.cart_add_url}`, {
        ...theme.utils.fetchConfig("javascript"),
        body,
      })
        .then((response) => response.json())
        .then(function () {
          if (document.querySelectorAll(".cart-bubble")) {
            fetch("/cart.js", { ...theme.utils.fetchConfig("javascript") })
              .then((cart) => cart.json())
              .then(function (cart) {
                document.querySelectorAll(".cart-bubble").forEach((bubble) => {
                  bubble.classList.remove("hide");
                  bubble.innerHTML = cart.item_count;
                });
              });
          }
          document.dispatchEvent(new CustomEvent("updateCart"));
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          setTimeout(function () {
            submitButton.style.overflow = "";
            submitButton.innerHTML = content;
            submitButton.classList.remove("loading");
            submitButton.removeAttribute("disabled");
          }, 2500);
        });
    }
  }
  customElements.define("bundle-products", BundleProducts);

  /* --- Search Bar */
  class SearchBar extends HTMLElement {
    constructor() {
      super();

      var self = this;

      this.completion = this.dataset.completion == "true" ? true : false;
      this.buttonSubmit = this.querySelector(".search-bar__button-submit");
      this.buttonClose = this.querySelector(".search-bar__button-close");
      this.form = this.querySelector("form");

      if (this.buttonSubmit) {
        this.buttonSubmit.addEventListener("click", self.open.bind(self));
      }

      if (this.buttonClose) {
        this.buttonClose.addEventListener("click", self.hide.bind(self));
      }

      this.form.addEventListener("submit", self.submit.bind(self));

      document.addEventListener("click", function (e) {
        if (
          e.target.closest("search-bar") == null &&
          self.classList.contains("active")
        )
          self.hide();
      });

      if (this.completion) {
        this.querySelector("input").addEventListener(
          "input",
          theme.utils.throttle(function () {
            setTimeout(function () {
              self.getSearch();
            }, 300);
          }, 300)
        );
      }
    }

    open() {
      if (this.buttonSubmit.dataset.click == "true") {
        this.submit();
      } else {
        this.classList.add("active");
        this.closest("section").style.overflow = "visible";
        this.buttonSubmit.dataset.click = true;
        this.querySelector('input[type="search"]').focus();
      }
    }

    hide() {
      this.classList.remove("active");
      this.buttonSubmit.dataset.click = false;
      if (this.closest("section")) this.closest("section").style.overflow = "";
      if (
        this.querySelector(".search-bar__result") &&
        this.querySelector(".search-bar__result.active")
      )
        this.querySelector(".search-bar__result.active").classList.remove(
          "active"
        );
      if (
        this.querySelector(".search-bar__result") &&
        !this.querySelector(".search-bar__result.hide")
      )
        this.querySelector(".search-bar__result").classList.add("hide");
      if (this.querySelector(".search-bar__empty"))
        this.querySelector(".search-bar__empty").classList.remove("hide");
    }

    submit() {
      if (this.buttonSubmit.dataset.click == "true") {
        this.form.submit();
      }
    }

    getSearch() {
      const resultsGrid = this.querySelector(".search-bar__result"),
        resultsContent = this.querySelector(".search-bar__result-content"),
        form = this.querySelector("form"),
        formSerialize = JSON.parse(theme.utils.serializeForm(form));

      if (formSerialize.q == "") {
        if (!resultsGrid.classList.contains("hide"))
          resultsGrid.classList.add("hide");
        return;
      }

      if (!resultsGrid.classList.contains("active"))
        resultsGrid.classList.add("active");
      if (resultsGrid.classList.contains("hide"))
        resultsGrid.classList.remove("hide");
      if (this.querySelector(".search-bar__empty"))
        this.querySelector(".search-bar__empty").classList.add("hide");

      resultsGrid.classList.add("loading");
      resultsContent.innerHTML = "";

      fetch(
        form.getAttribute("action") +
          "?q=" +
          formSerialize.q +
          "&options%5Bprefix%5D=last",
        { ...theme.utils.fetchConfig("javascript") }
      )
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(
            responseText,
            "text/html"
          );

          const Source_resultsContent = html.querySelector(
            "#main-collection-product-grid"
          );

          if (Source_resultsContent && resultsContent)
            resultsContent.innerHTML = Source_resultsContent.innerHTML;
          resultsGrid.classList.remove("loading");
          resultsGrid.classList.remove("hide");
        });
    }
  }
  customElements.define("search-bar", SearchBar);

  /* --- Menu Drawer */
  class MenuDrawer extends HTMLElement {
    constructor() {
      super();

      var self = this;

      this.mainDetailsToggle = this.querySelector("details");
      const summaryElements = this.querySelectorAll("summary");
      this.side = this.querySelector(".menu-drawer--right") ? "right" : "left";
      this.addAccessibilityAttributes(summaryElements);

      if (this.dataset.menuButton)
        this.hamburgerButtons = document
          .querySelectorAll(".menu--hamburger--container")
          .forEach((button) => {
            button.addEventListener("click", this.onMenuButtonClick.bind(this));
          });

      if (navigator.platform === "iPhone")
        document.documentElement.style.setProperty(
          "--viewport-height",
          `${window.innerHeight}px`
        );

      this.addEventListener("keyup", this.onKeyUp.bind(this));
      this.addEventListener("focusout", this.onFocusOut.bind(this));
      this.bindEvents();

      this.addEventListener("click", function (e) {
        if (e.target.classList.contains("menu-drawer--content"))
          self.closeMenuDrawer(e.target.closest("details[open]"));
      });

      document.addEventListener("shopify:section:load", function (e) {
        self.is_reloading = true;
        self.closeMenuDrawer(e, self.mainDetailsToggle);
        self.reload(e);
        self.is_reloading = false;

        if (this.hamburgerButtons)
          this.hamburgerButtons.forEach((button) => {
            if (
              button.dataset.fixed &&
              button.dataset.fixed == "true" &&
              document.documentElement.clientWidth > 780
            )
              button.classList.add("hide"), this.fixedSidebar();
            else button.classList.remove("hide"), this.unfixedSidebar();
          });
      });
    }

    reload(event) {
      if (
        this.mainDetailsToggle.closest(
          ".drawer:not(.header__sidebar-section)"
        ) &&
        event.target.classList.contains(
          "drawer:not(.header__sidebar-section)"
        ) &&
        !this.mainDetailsToggle.hasAttribute("open")
      ) {
        this.onMenuButtonClick(event.target);
      }
    }

    fixedSidebar() {
      document.body.classList.add("sidebar-fixed");
      const summaryElement = this.querySelector("summary.drawer-first");
      const detailsElement = summaryElement.parentNode;

      detailsElement.setAttribute("open", ""),
        detailsElement.classList.add("menu-drawer--fixed");
    }

    unfixedSidebar() {
      document.body.classList.remove("sidebar-fixed");
      const summaryElement = this.querySelector("summary.drawer-first");
      const detailsElement = summaryElement.parentNode;
      const buttons = document.querySelectorAll(".menu--hamburger--container");

      detailsElement.removeAttribute("open"),
        detailsElement.classList.remove("menu-drawer--fixed"),
        buttons.forEach((button) => {
          button.classList.remove("active");
        });
    }

    bindEvents() {
      this.querySelectorAll("summary:not([data-localization])").forEach(
        (summary) =>
          summary.addEventListener("click", this.onSummaryClick.bind(this))
      );
      this.querySelectorAll(".menu-drawer__close-button").forEach((button) =>
        button.addEventListener("click", this.onCloseButtonClick.bind(this))
      );
      if (this.querySelector(".modal__close"))
        this.querySelector(".modal__close").addEventListener(
          "click",
          this.onCloseButtonClick.bind(this)
        );

      this.querySelectorAll(".menu-drawer__summary a[data-click]").forEach(
        (link) => {
          link.addEventListener("click", function (e) {
            this.dataset.click == "true"
              ? false
              : (e.preventDefault(), (this.dataset.click = true));
            if (this.closest(".link_collapsing_title")) {
              e.preventDefault();
            }
          });

          if (link.closest(".link_collapsing_title")) {
            link.addEventListener("dblclick", function () {
              window.location.href = this.href;
            });
          }
        }
      );
    }

    addAccessibilityAttributes(summaryElements) {
      summaryElements.forEach((element) => {
        element.setAttribute("aria-expanded", false);
        element.setAttribute("aria-controls", element.nextElementSibling.id);
      });
    }

    onKeyUp(event) {
      if (event.code.toUpperCase() !== "ESCAPE") return;

      const openDetailsElement = event.target.closest("details[open]");
      if (!openDetailsElement) return;

      openDetailsElement === this.mainDetailsToggle
        ? this.closeMenuDrawer(this.mainDetailsToggle.querySelector("summary"))
        : this.closeSubmenu(openDetailsElement);
    }

    onMenuButtonClick(event) {
      const buttons = document.querySelectorAll(".menu--hamburger--container");
      const summaryElement = this.querySelector("summary.drawer-first");
      const detailsElement = summaryElement.parentNode;
      const isOpen = detailsElement.hasAttribute("open");

      isOpen
        ? (event.preventDefault(),
          event.stopPropagation(),
          this.closeMenuDrawer(summaryElement))
        : (detailsElement.setAttribute("open", ""),
          this.openMenuDrawer(summaryElement),
          buttons.forEach((button) => {
            button.classList.add("active");
            if (
              button.dataset.fixed &&
              button.dataset.fixed == "true" &&
              document.documentElement.clientWidth > 780
            )
              this.fixedSidebar();
            else if (document.body.classList.contains("sidebar-fixed"))
              this.unfixedSidebar();
          }));
    }

    onSummaryClick(event) {
      const summaryElement = event.currentTarget;
      const detailsElement = summaryElement.parentNode;
      const isOpen = detailsElement.hasAttribute("open");

      if (isOpen) event.preventDefault(), event.stopPropagation();

      if (detailsElement === this.mainDetailsToggle) {
        isOpen
          ? this.closeMenuDrawer(summaryElement)
          : this.openMenuDrawer(summaryElement);
      } else {
        if (isOpen) {
          this.closeSubmenu(summaryElement);
        } else if (this.closest(".drawer"))
          detailsElement.setAttribute("open", "");
        trapFocus(
          summaryElement.nextElementSibling,
          detailsElement.querySelector("button")
        );

        setTimeout(() => {
          detailsElement.classList.add("menu-opening");
        });
      }
    }

    openMenuDrawer(summaryElement) {
      (document.body.style.top = `-${window.pageYOffset}px`),
        document.body.classList.add("overflow-hidden-fixed");
      setTimeout(() => {
        this.mainDetailsToggle.classList.add("menu-opening");
      });
      summaryElement.setAttribute("aria-expanded", true);
      trapFocus(this.mainDetailsToggle, summaryElement);
    }

    closeMenuDrawer(event, elementToFocus = false) {
      if (
        event === undefined ||
        (event.target &&
          this.mainDetailsToggle.querySelector(
            `#${event.target.id.replace("shopify-section-", "")}`
          ))
      ) {
        return false;
      }

      var self = this;
      if (this.dataset.menuButton)
        document
          .querySelectorAll(".menu--hamburger--container")
          .forEach((button) => {
            button.classList.remove("active"), this.unfixedSidebar();
          });
      this.mainDetailsToggle.classList.remove("menu-opening");

      this.mainDetailsToggle.querySelectorAll("details").forEach((details) => {
        details.removeAttribute("open");
        details.classList.remove("menu-opening");
      });

      this.mainDetailsToggle
        .querySelector("summary")
        .setAttribute("aria-expanded", false);

      if (!self.is_reloading) {
        (this.scrollY = document.body.style.top),
          (document.body.style.top = ""),
          document.body.classList.remove("overflow-hidden-fixed"),
          window.scrollTo({
            left: 0,
            top: parseInt(this.scrollY || "0") * -1,
            behavior: "instant",
          });
      }

      removeTrapFocus(elementToFocus);
      this.closeAnimation(this.mainDetailsToggle);
    }

    onFocusOut(event) {
      setTimeout(() => {
        if (
          this.mainDetailsToggle.hasAttribute("open") &&
          !this.mainDetailsToggle.contains(document.activeElement)
        )
          this.closeMenuDrawer();
      });
    }

    onCloseButtonClick(event) {
      if (event.target.closest("details") === this.mainDetailsToggle)
        this.closeMenuDrawer(event.target.closest("details"));
      else this.closeSubmenu(event.target.closest("details"));
    }

    closeSubmenu(detailsElement) {
      removeTrapFocus();
      this.closeAnimation(detailsElement);
    }

    closeAnimation(detailsElement) {
      let animationStart;

      detailsElement.classList.remove("menu-opening");

      this.querySelectorAll(".menu-drawer__summary a[data-click]").forEach(
        (link) => {
          link.dataset.click = false;
        }
      );

      const handleAnimation = (time) => {
        if (animationStart === undefined) {
          animationStart = time;
        }

        const elapsedTime = time - animationStart;

        if (elapsedTime < 400) {
          window.requestAnimationFrame(handleAnimation);
        } else {
          detailsElement.removeAttribute("open");
          if (detailsElement.closest("details[open]")) {
            trapFocus(
              detailsElement.closest("details[open]"),
              detailsElement.querySelector("summary")
            );
          }
        }
      };

      window.requestAnimationFrame(handleAnimation);
    }
  }
  customElements.define("menu-drawer", MenuDrawer);

  /* Addon: Form No Challenge */
  var formNoChallenge = document.querySelectorAll("form.no-challenge");
  if (formNoChallenge.length > 0) {
    formNoChallenge.forEach((form) => {
      window.addEventListener("load", () => {
        if (Shopify.recaptchaV3) {
          let x = setInterval(() => {
            if (form.getAttribute("onsubmit") != null) {
              form.removeAttribute("onsubmit");
              clearInterval(x);
            }
          }, 100);
        }
      });

      if (!form.closest(".popup_spin__newsletter")) {
        form.addEventListener("submit", function (e) {
          const body = JSON.stringify({
            ...JSON.parse(theme.utils.serializeForm(form)),
          });

          fetch(form.getAttribute("action"), {
            ...theme.utils.fetchConfig("javascript"),
            body,
          })
            .then(() => {
              e.preventDefault();
              let message =
                '<p class="form-success"> ' +
                Shopify.translation.posted_successfully +
                "</p>";
              form.innerHTML = message;
            })
            .catch(() => {
              if (e.status == 429) {
                // Allow for default redirect to challenge form, do not force
                console.log("Allow default window redirection for challenge");
              }
              form.classList.remove("no-challenge");
              form.submit();
            });
        });
      }
    });
  }

  /*============================================================================
    Things that require DOM to be ready
  ==============================================================================*/
  function ButtonStyle() {
    if (Shopify.theme_settings.btnPrimaryStyle != "none") {
      var buttons = document.querySelectorAll(
        ".btn:not(.btn--narrow):not(.btn--no-style)"
      );

      buttons.forEach((btn) => {
        if (btn.querySelector("span.btn--arrow"))
          btn.querySelector("span.btn--arrow").remove();
        if (btn.querySelectorAll("span.line").length > 0)
          btn
            .querySelectorAll("span.line")
            .forEach((btnLined) => btnLined.remove());
        if (btn.querySelectorAll("span.lined").length > 0)
          btn
            .querySelectorAll("span.lined")
            .forEach((btnLined) => btnLined.remove());

        btn.classList.add(Shopify.theme_settings.btnPrimaryStyle);

        if (
          Shopify.theme_settings.btnPrimaryStyle == "btn--arrow" &&
          !btn.querySelector("span.svg_arrow")
        ) {
          btn.innerHTML +=
            "<span class='svg_arrow'>" +
            Shopify.theme_settings.btnArrow +
            "</span>";
        } else if (
          Shopify.theme_settings.btnPrimaryStyle == "btn--frame" &&
          !btn.querySelector("span.line.-right")
        ) {
          btn.innerHTML +=
            '<span class="line -right"></span><span class="line -top"></span><span class="line -left"></span><span class="line -bottom"></span>';
        } else if (
          Shopify.theme_settings.btnPrimaryStyle == "btn--futur" &&
          !btn.querySelector("span.lined_bottom")
        ) {
          btn.innerHTML +=
            "<span class='lined lined_bottom'></span><span class='lined lined_right'></span><span class='lined lined_top'></span><span class='lined lined_left'></span>";
        }
      });
    }

    if (Shopify.theme_settings.btnSecondaryStyle != "none") {
      var buttons = document.querySelectorAll(
        ".btn--secondary:not(.btn--narrow):not(.btn--no-style)"
      );

      buttons.forEach((btn) => {
        if (btn.querySelector("span.btn--arrow"))
          btn.querySelector("span.btn--arrow").remove();
        if (btn.querySelectorAll("span.line").length > 0)
          btn
            .querySelectorAll("span.line")
            .forEach((btnLined) => btnLined.remove());
        if (btn.querySelectorAll("span.lined").length > 0)
          btn
            .querySelectorAll("span.lined")
            .forEach((btnLined) => btnLined.remove());

        btn.classList.add(Shopify.theme_settings.btnSecondaryStyle);

        if (
          Shopify.theme_settings.btnSecondaryStyle == "btn--arrow" &&
          !btn.querySelector("span.svg_arrow")
        ) {
          btn.innerHTML +=
            "<span class='svg_arrow'>" +
            Shopify.theme_settings.btnArrow +
            "</span>";
        } else if (
          Shopify.theme_settings.btnSecondaryStyle == "btn--frame" &&
          !btn.querySelector("span.line.-right")
        ) {
          btn.innerHTML +=
            '<span class="line -right"></span><span class="line -top"></span><span class="line -left"></span><span class="line -bottom"></span>';
        } else if (
          Shopify.theme_settings.btnSecondaryStyle == "btn--futur" &&
          !btn.querySelector("span.lined_bottom")
        ) {
          btn.innerHTML +=
            "<span class='lined lined_bottom'></span><span class='lined lined_right'></span><span class='lined lined_top'></span><span class='lined lined_left'></span>";
        }
      });
    }

    if (Shopify.theme_settings.btnAtcStyle != "none") {
      var buttons = document.querySelectorAll(
        ".btn--atc:not(.btn--no-style):not([disabled])"
      );

      buttons.forEach((btn) => {
        if (btn.querySelector("span.btn--arrow"))
          btn.querySelector("span.btn--arrow").remove();
        if (btn.querySelectorAll("span.line").length > 0)
          btn
            .querySelectorAll("span.line")
            .forEach((btnLined) => btnLined.remove());
        if (btn.querySelectorAll("span.lined").length > 0)
          btn
            .querySelectorAll("span.lined")
            .forEach((btnLined) => btnLined.remove());

        btn.classList.add(Shopify.theme_settings.btnAtcStyle);

        if (
          Shopify.theme_settings.btnAtcStyle == "btn--arrow" &&
          !btn.querySelector("span.svg_arrow")
        ) {
          btn.innerHTML +=
            "<span class='svg_arrow'>" +
            Shopify.theme_settings.btnArrow +
            "</span>";
        } else if (
          Shopify.theme_settings.btnAtcStyle == "btn--frame" &&
          !btn.querySelector("span.line.-right")
        ) {
          btn.innerHTML +=
            '<span class="line -right"></span><span class="line -top"></span><span class="line -left"></span><span class="line -bottom"></span>';
        } else if (
          Shopify.theme_settings.btnAtcStyle == "btn--futur" &&
          !btn.querySelector("span.lined_bottom")
        ) {
          btn.innerHTML +=
            "<span class='lined lined_bottom'></span><span class='lined lined_right'></span><span class='lined lined_top'></span><span class='lined lined_left'></span>";
        }
      });
    }

    function CheckoutStyle(btn) {
      if (document.querySelector("style#shopify-dynamic-checkout")) {
        document.querySelector("style#shopify-dynamic-checkout").remove();
      }

      if (btn.querySelector("span.btn--arrow"))
        btn.querySelector("span.btn--arrow").remove();
      if (btn.querySelectorAll("span.line").length > 0)
        btn
          .querySelectorAll("span.line")
          .forEach((btnLined) => btnLined.remove());
      if (btn.querySelectorAll("span.lined").length > 0)
        btn
          .querySelectorAll("span.lined")
          .forEach((btnLined) => btnLined.remove());

      btn.classList.add(Shopify.theme_settings.btnCheckoutStyle);

      if (
        Shopify.theme_settings.btnCheckoutStyle == "btn--arrow" &&
        !btn.querySelector("span.svg_arrow")
      ) {
        btn.innerHTML +=
          "<span class='svg_arrow'>" +
          Shopify.theme_settings.btnArrow +
          "</span>";
      } else if (
        Shopify.theme_settings.btnCheckoutStyle == "btn--frame" &&
        !btn.querySelector("span.line.-right")
      ) {
        btn.innerHTML +=
          '<span class="line -right"></span><span class="line -top"></span><span class="line -left"></span><span class="line -bottom"></span>';
      } else if (
        Shopify.theme_settings.btnCheckoutStyle == "btn--futur" &&
        !btn.querySelector("span.lined_bottom")
      ) {
        btn.innerHTML +=
          "<span class='lined lined_bottom'></span><span class='lined lined_right'></span><span class='lined lined_top'></span><span class='lined lined_left'></span>";
      }
    }

    if (Shopify.theme_settings.btnCheckoutStyle != "none") {
      var buttons = document.querySelectorAll(".shopify-payment-button");
      buttons.forEach((btn) => {
        var x = setInterval(function () {
          var btnUnbranded = btn.querySelector(
            ".shopify-payment-button__button"
          );
          if (
            !btnUnbranded.classList.contains(
              "shopify-payment-button__button--unbranded"
            )
          ) {
            clearInterval(x);
          } else if (btnUnbranded.innerHTML.length > 6) {
            clearInterval(x);
            CheckoutStyle(btnUnbranded);
          }
        }, 300);
      });
    }
  }

  theme.init = function () {
    var images = document.querySelectorAll("section img");

    images.forEach((image) => {
      if (theme.utils.isInViewport(image)) {
        image.setAttribute("loading", "eager");
      }
    });

    if ("IntersectionObserver" in window) {
      let lazyBackgroundObserver = new IntersectionObserver(function (
        entries,
        observer
      ) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add("visible");
            lazyBackgroundObserver.unobserve(entry.target);
          }
        });
      });

      document.querySelectorAll("img", "svg").forEach((lazyBackground) => {
        lazyBackgroundObserver.observe(lazyBackground);
      });
    }

    var videos = document.querySelectorAll("video");

    videos.forEach((video) => {
      if (theme.utils.isInViewport(video) && video.offsetHeight > 0) {
        video.classList.remove("video-lazy");
      } else {
        video.classList.add("video-lazy");
        if (video.querySelector("source")) {
          (video.dataset.srcVideo = video.querySelector("source").src),
            video.querySelector("source").removeAttribute("src");
        } else {
          (video.dataset.srcVideo = video.src), video.removeAttribute("src");
        }
      }
    });

    var lazyVideos = [].slice.call(
      document.querySelectorAll("video.video-lazy")
    );

    if ("IntersectionObserver" in window) {
      var lazyVideoObserver = new IntersectionObserver(function (
        entries,
        observer
      ) {
        entries.forEach(function (video) {
          if (video.isIntersecting) {
            var videoSource = video.target;
            if (
              videoSource.querySelector("source") &&
              videoSource.querySelector("source").src
            ) {
              videoSource.querySelector("source").src =
                videoSource.dataset.srcVideo;
            } else {
              videoSource.src = videoSource.dataset.srcVideo;
            }
            videoSource.load();
            videoSource.classList.remove("lazy");
            lazyVideoObserver.unobserve(videoSource);
            if (videoSource.closest("deffered-media")) {
              videoSource.closest("deferred-media").playContent();
            }
          }
        });
      });

      lazyVideos.forEach((lazyVideo) => {
        lazyVideoObserver.observe(lazyVideo);
      });
    }

    localStorage.setItem("shopify_loaded", 1);

    ButtonStyle();
    document.addEventListener("shopify:section:load", function (e) {
      ButtonStyle();
    });

    if (
      Shopify.theme_settings.lottieFiles == true &&
      document.querySelectorAll("lottie-player").length > 0
    ) {
      theme.utils.getScript(
        "https://unpkg.com/@lottiefiles/lottie-player@latest/dist/lottie-player.js"
      );
    }
  };

  theme.register = function () {
    theme.sections.register("header", theme.Header);
    theme.sections.register("swiper-slider", theme.Swiper_Slider);
    theme.sections.register("cart", theme.Cart);
    theme.sections.register("article", theme.Article);
    theme.sections.register("blog", theme.Blog);
    theme.sections.register("tracking-genie", theme.TrackingGenie);
    theme.sections.register("tracking", theme.Tracking);
    theme.sections.register(
      "product-recommendations",
      theme.ProductRecommendations
    );
    theme.sections.register("map", theme.Map);
    theme.sections.register("gallery", theme.Gallery);
    theme.sections.register("social-feed", theme.Feed);
    theme.sections.register("shopping-feed-insta", theme.ShoppingFeedInsta);
    theme.sections.register("rgpd-cookies", theme.RGPD);
    theme.sections.register("popup-age-verification", theme.AgeVerification);
    theme.sections.register("popup-orders-notif", theme.OrdersNotif);
    theme.sections.register("popup-newsletter", theme.PopupNewsletter);
    theme.sections.register("popup-spin", theme.PopupSpin);
  };

  document.addEventListener("DOMContentLoaded", function () {
    theme.init();
    theme.sections = new theme.Sections();
    theme.register();

    if (document.body.classList.contains("template-customers")) {
      theme.Login();
    }
  });

  /* --- App: Security */
  if (Shopify.theme_settings.enable_security) {
    let sd_small_devices,
      sdbodyText,
      imageSelectStyle,
      textProtectionStyle,
      imageDragStyle,
      disableDragAndDrop;
    (sd_small_devices = window.navigator.userAgent.match(/mobi/i)),
      sd_small_devices
        ? ((sdbodyText = document.createElement("style")),
          (sdbodyText.type = "text/css"),
          (sdbodyText.innerHTML =
            "body {-webkit-touch-callout: none;-webkit-user-select: none;-khtml-user-select: none;-moz-user-select: none;-ms-user-select: none;user-select: none;}"),
          document.head.appendChild(sdbodyText),
          (imageSelectStyle = document.createElement("style")),
          (imageSelectStyle.type = "text/css"),
          (imageSelectStyle.innerHTML =
            "img {-webkit-touch-callout: none;-webkit-user-select: none;-khtml-user-select: none;-moz-user-select: none;-ms-user-select: none;user-select: none;pointer-events: none;}a > img {pointer-events: auto;}.flex-control-thumbs li > img {pointer-events: auto;}"),
          document.head.appendChild(imageSelectStyle),
          document.addEventListener("contextmenu", function (e) {
            "img" === (e.target || e.srcElement).tagName.toLowerCase() &&
              e.preventDefault();
          }))
        : (document.addEventListener("contextmenu", function (e) {
            "input" !== (e.target || e.srcElement).tagName.toLowerCase() &&
              "textarea" !== (e.target || e.srcElement).tagName.toLowerCase() &&
              e.preventDefault();
          }),
          document.addEventListener("contextmenu", function (e) {
            "input" !== (e.target || e.srcElement).tagName.toLowerCase() &&
              "textarea" !== (e.target || e.srcElement).tagName.toLowerCase() &&
              (e.target || e.srcElement).innerText &&
              e.preventDefault();
          }),
          (textProtectionStyle = document.createElement("style")),
          (textProtectionStyle.type = "text/css"),
          (textProtectionStyle.innerHTML =
            "body {-webkit-touch-callout: none;-webkit-user-select: none;-khtml-user-select: none;-moz-user-select: none;-ms-user-select: none;user-select: none;}.powr-countdown-timer iframe {pointer-events: none;}"),
          document.head.appendChild(textProtectionStyle),
          document.addEventListener("mousedown", function (e) {
            "img" === (e.target || e.srcElement).tagName.toLowerCase() &&
              2 == e.which &&
              e.preventDefault();
          }),
          document.addEventListener("contextmenu", function (e) {
            "img" === (e.target || e.srcElement).tagName.toLowerCase() &&
              e.preventDefault();
          }),
          (imageDragStyle = document.createElement("style")),
          (imageDragStyle.type = "text/css"),
          (imageDragStyle.innerHTML =
            "img {-webkit-user-drag: none;user-drag: none;}"),
          document.head.appendChild(imageDragStyle),
          (disableDragAndDrop = function () {
            document.body.setAttribute("ondragstart", "return false;"),
              document.body.setAttribute("ondrop", "return false;");
          }),
          "complete" === document.readyState
            ? disableDragAndDrop()
            : document.addEventListener("DOMContentLoaded", disableDragAndDrop),
          document.addEventListener("contextmenu", function (e) {
            (e.target || e.srcElement).style.backgroundImage &&
              e.preventDefault();
          }),
          document.addEventListener("copy", function (e) {
            "input" !== (e.target || e.srcElement).tagName.toLowerCase() &&
              "textarea" !== (e.target || e.srcElement).tagName.toLowerCase() &&
              e.preventDefault();
          }),
          document.addEventListener("cut", function (e) {
            "input" != (e.target || e.srcElement).tagName.toLowerCase() &&
              "textarea" != (e.target || e.srcElement).tagName.toLowerCase() &&
              e.preventDefault();
          }));

    var shopurl = window.location.href,
      selectSortBy = document.getElementById("SortBy");
    if (selectSortBy)
      for (var i = 0; i < selectSortBy.length; i++)
        "best-selling" == selectSortBy.options[i].value &&
          selectSortBy.remove(i);
    var url = shopurl + "/collections/all?sort_by=best-selling";

    if (
      (document.location.href.indexOf(url) > -1 &&
        (document.location.href = shopurl + "/collections/all"),
      !sd_small_devices)
    ) {
      function copyToClipboard() {
        navigator.clipboard.writeText(""),
          alert(Shopify.translation.security.screenshot);
      }

      document.addEventListener("keydown", function (e) {
        if (
          e.code === "F12" ||
          (e.ctrlKey && e.shiftKey && e.code === "KeyI")
        ) {
          e.preventDefault(),
            e.stopPropagation(),
            alert(Shopify.translation.security.disabled),
            !1;
        }
      });

      document.addEventListener("keydown", function (e) {
        return (
          !e.ctrlKey ||
          ("KeyC" !== e.code &&
            "KeyV" !== e.code &&
            "KeyU" !== e.code &&
            "ControlLeft" !== e.code &&
            "ControlRight" !== e.code &&
            "KeyU" !== e.code) ||
          alert(Shopify.translation.security.disabled)
        );
      });

      document.addEventListener("keydpress", function (e) {
        if ("PrintScreen" === e.code)
          e.preventDefault(), e.stopPropagation(), copyToClipboard();
      });

      document.querySelectorAll("video").forEach((video) => {
        video.setAttribute("controlsList", "nodownload");
      });
    }

    document.addEventListener("keypress", function (e) {
      return (
        ((("F4" !== e.code && "KeyS" !== e.code) ||
          (!e.ctrlKey && !e.metaKey)) &&
          "pause/break" !== e.key) ||
        (e.preventDefault(), !1)
      );
    });

    document.addEventListener("keydown", function (e) {
      if (e.ctrlKey && "KeyS" == e.code)
        e.preventDefault(), alert(Shopify.translation.security.disabled), !1;
      (e.ctrlKey || e.metaKey) && "KeyS" == e.code
        ? (e.preventDefault(), !1)
        : (e.ctrlKey || e.metaKey) && "pause/break" == e.key
        ? (e.preventDefault(), !1)
        : void 0;
      !e.ctrlKey ||
        ("KeyC" !== e.code &&
          "KeyV" !== e.code &&
          "KeyU" !== e.code &&
          "F6" !== e.code) ||
        (alert(Shopify.translation.security.disabled), !1);
      !e.ctrlKey ||
        ("KeyP" != e.code &&
          "ShiftLeft" !== e.code &&
          "ShiftRight" !== e.code &&
          "F1" !== e.code &&
          "KeyP" !== e.code) ||
        (alert(Shopify.translation.security.disabled),
        (e.cancelBubble = !0),
        e.preventDefault(),
        e.stopImmediatePropagation());
    });
  }
})();
